/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


/**
 * Basic API CRUD access to Invoice entities.
 */
export const InvoicesListQueryParams = zod.object({
  "cars": zod.array(zod.string().uuid()).optional().describe('Filter invoices by one or more serviced car IDs (repeat the param)'),
  "date_end": zod.string().date().optional().describe('End of the date range (inclusive).'),
  "date_stamped_end": zod.string().date().optional().describe('End of the date_stamped range (inclusive).'),
  "date_stamped_start": zod.string().date().optional().describe('Start of the date_stamped range (inclusive).'),
  "date_start": zod.string().date().optional().describe('Start of the date range (inclusive).'),
  "date_uploaded_end": zod.string().date().optional().describe('End of the date_uploaded range (inclusive).'),
  "date_uploaded_start": zod.string().date().optional().describe('Start of the date_uploaded range (inclusive).'),
  "dispute_needs_attention": zod.boolean().optional(),
  "dispute_status": zod.array(zod.enum(['active', 'awaiting-vendor', 'none', 'resolved', 'withdrawn'])).optional().describe('\* `none` - None\n\* `active` - Active\n\* `awaiting-vendor` - Awaiting Vendor\n\* `resolved` - Resolved\n\* `withdrawn` - Withdrawn'),
  "is_adjustment": zod.boolean().optional(),
  "kind": zod.array(zod.enum(['credit', 'invoice', 'proposal'])).optional().describe('\* `invoice` - Invoice\n\* `proposal` - Proposal\n\* `credit` - Credit'),
  "limit": zod.number().optional().describe('Number of results to return per page.'),
  "number": zod.string().optional(),
  "offset": zod.number().optional().describe('The initial index from which to return the results.'),
  "ordering": zod.string().optional().describe('Comma-separated ordering fields; prefix with `-` for descending.'),
  "portfolio": zod.array(zod.string().uuid()).optional(),
  "portfolio_name": zod.string().optional(),
  "property": zod.string().uuid().optional(),
  "property_name": zod.string().optional(),
  "proposed_amount": zod.number().optional(),
  "proposed_amount_gt": zod.number().optional(),
  "proposed_amount_gte": zod.number().optional(),
  "proposed_amount_lt": zod.number().optional(),
  "proposed_amount_lte": zod.number().optional(),
  "query": zod.string().optional(),
  "region": zod.array(zod.string().nullable()).optional(),
  "rejection_category": zod.array(zod.array(zod.enum(['billing-rate-incorrect', 'no-time-tickets', 'required-hours-incorrect', 'miscellaneous-fees', 'covered-by-contract', 'work-not-required', 'material-markup-incorrect', 'material-quantity-incorrect', 'pre-negotiated-price-not-followed', 'other']).describe('\* `billing-rate-incorrect` - Billing Rate Incorrect\n\* `no-time-tickets` - No Time Tickets\n\* `required-hours-incorrect` - Required Hours Incorrect\n\* `miscellaneous-fees` - Miscellaneous Fees\n\* `covered-by-contract` - Covered By Contract\n\* `work-not-required` - Work Not Required\n\* `material-markup-incorrect` - Material Markup Incorrect\n\* `material-quantity-incorrect` - Material Quantity Incorrect\n\* `pre-negotiated-price-not-followed` - Pre-negotiated Price Not Followed\n\* `other` - Other')).nullable()).optional().describe('\* `billing-rate-incorrect` - Billing Rate Incorrect\n\* `no-time-tickets` - No Time Tickets\n\* `required-hours-incorrect` - Required Hours Incorrect\n\* `miscellaneous-fees` - Miscellaneous Fees\n\* `covered-by-contract` - Covered By Contract\n\* `work-not-required` - Work Not Required\n\* `material-markup-incorrect` - Material Markup Incorrect\n\* `material-quantity-incorrect` - Material Quantity Incorrect\n\* `pre-negotiated-price-not-followed` - Pre-negotiated Price Not Followed\n\* `other` - Other'),
  "related_invoices": zod.string().optional(),
  "reviewed_amount": zod.number().optional(),
  "reviewed_amount_gt": zod.number().optional(),
  "reviewed_amount_gte": zod.number().optional(),
  "reviewed_amount_lt": zod.number().optional(),
  "reviewed_amount_lte": zod.number().optional(),
  "savings": zod.number().optional(),
  "savings_gt": zod.number().optional(),
  "savings_gte": zod.number().optional(),
  "savings_lt": zod.number().optional(),
  "savings_lte": zod.number().optional(),
  "search": zod.string().optional(),
  "service_provider": zod.array(zod.string().uuid()).optional(),
  "status": zod.array(zod.enum(['approved', 'partial-approval', 'pending', 'pending-data', 'rejected', 'reset'])).optional().describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "tickets": zod.string().optional(),
  "type": zod.array(zod.enum(['callback', 'fee', 'inspection', 'maintenance', 'modernization', 'repair'])).optional().describe('\* `maintenance` - Maintenance\n\* `modernization` - Modernization\n\* `callback` - Callback\n\* `inspection` - Inspection\n\* `repair` - Repair\n\* `fee` - Late Fee \/ Service Fee'),
  "variant": zod.enum(['default', 'form', 'table']).optional().describe('Field-subset variant. Omit for the full default shape; `form` returns the trimmed InvoiceForm shape and `table` the InvoiceTable shape.'),
  "vendor_name": zod.string().optional()
})

export const invoicesListResponseResultsItemOneNumberMax = 100;

export const invoicesListResponseResultsItemOneConsultantOneUsernameMax = 150;


export const invoicesListResponseResultsItemOneConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const invoicesListResponseResultsItemOneConsultantOneEmailMax = 254;

export const invoicesListResponseResultsItemOneConsultantOnePhoneNumberMax = 128;

export const invoicesListResponseResultsItemOneProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemOneReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemOneApprovedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemOneLineItemsItemAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemOneAttachmentsItemPageNumberMin = 0;
export const invoicesListResponseResultsItemOneAttachmentsItemPageNumberMax = 2147483647;

export const invoicesListResponseResultsItemOneSavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemOneTicketsItemNumberMax = 20;

export const invoicesListResponseResultsItemOneRelatedInvoicesItemNumberMax = 100;

export const invoicesListResponseResultsItemOneRelatedInvoicesItemProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemOneRelatedInvoicesItemReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemOneRelatedInvoicesItemAttachmentsItemPageNumberMin = 0;
export const invoicesListResponseResultsItemOneRelatedInvoicesItemAttachmentsItemPageNumberMax = 2147483647;

export const invoicesListResponseResultsItemOneParentInvoiceOneNumberMax = 100;

export const invoicesListResponseResultsItemOneParentInvoiceOneProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemOneAdjustmentsItemNumberMax = 100;

export const invoicesListResponseResultsItemOneAdjustmentsItemProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemOneCreditedInvoiceOneNumberMax = 100;

export const invoicesListResponseResultsItemOneCreditedInvoiceOneProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemOneCreditedInvoiceOneReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemOneCreditedInvoiceOneSavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemOneCreditedInvoiceOneDisputeSavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemOneCreditsItemNumberMax = 100;

export const invoicesListResponseResultsItemOneCreditsItemProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemOneUploadedByOneUsernameMax = 150;


export const invoicesListResponseResultsItemOneUploadedByOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const invoicesListResponseResultsItemOneUploadedByOneEmailMax = 254;

export const invoicesListResponseResultsItemOneUploadedByOnePhoneNumberMax = 128;

export const invoicesListResponseResultsItemTwoNumberMax = 100;

export const invoicesListResponseResultsItemThreeNumberMax = 100;

export const invoicesListResponseResultsItemThreeConsultantOneUsernameMax = 150;


export const invoicesListResponseResultsItemThreeConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const invoicesListResponseResultsItemThreeConsultantOneEmailMax = 254;

export const invoicesListResponseResultsItemThreeConsultantOnePhoneNumberMax = 128;

export const invoicesListResponseResultsItemThreeProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemThreeReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemThreeSavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemThreeTicketsItemNumberMax = 20;

export const invoicesListResponseResultsItemThreeRelatedInvoicesItemNumberMax = 100;

export const invoicesListResponseResultsItemThreeRelatedInvoicesItemProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemThreeRelatedInvoicesItemReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesListResponseResultsItemThreeRelatedInvoicesItemAttachmentsItemPageNumberMin = 0;
export const invoicesListResponseResultsItemThreeRelatedInvoicesItemAttachmentsItemPageNumberMax = 2147483647;



export const InvoicesListResponse = zod.object({
  "count": zod.number(),
  "next": zod.string().url().nullish(),
  "previous": zod.string().url().nullish(),
  "metadata": zod.object({
  "numInvoices": zod.number().optional(),
  "numPendingInvoices": zod.number().optional(),
  "reviewedInvoices": zod.number().optional(),
  "invoiceAmount": zod.number().optional(),
  "afterReview": zod.number().optional(),
  "savings": zod.number().optional(),
  "rejectedDollars": zod.number().optional(),
  "projectedSavings": zod.number().optional(),
  "vendorCredits": zod.number().optional()
}).strict(),
  "results": zod.array(zod.union([zod.object({
  "number": zod.string().max(invoicesListResponseResultsItemOneNumberMax),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "disputeStatus": zod.enum(['none', 'active', 'awaiting-vendor', 'resolved', 'withdrawn']).optional().describe('\* `none` - None\n\* `active` - Active\n\* `awaiting-vendor` - Awaiting Vendor\n\* `resolved` - Resolved\n\* `withdrawn` - Withdrawn'),
  "disputeNeedsAttention": zod.boolean().describe('Returns True when the dispute is active and a vendor response\nhas been analyzed, indicating the consultant needs to take action.'),
  "type": zod.enum(['maintenance', 'modernization', 'callback', 'inspection', 'repair', 'fee']).describe('\* `maintenance` - Maintenance\n\* `modernization` - Modernization\n\* `callback` - Callback\n\* `inspection` - Inspection\n\* `repair` - Repair\n\* `fee` - Late Fee \/ Service Fee'),
  "kind": zod.enum(['invoice', 'proposal', 'credit']).describe('\* `invoice` - Invoice\n\* `proposal` - Proposal\n\* `credit` - Credit'),
  "reason": zod.string().optional(),
  "rejectionCategory": zod.array(zod.enum(['billing-rate-incorrect', 'no-time-tickets', 'required-hours-incorrect', 'miscellaneous-fees', 'covered-by-contract', 'work-not-required', 'material-markup-incorrect', 'material-quantity-incorrect', 'pre-negotiated-price-not-followed', 'other']).describe('\* `billing-rate-incorrect` - Billing Rate Incorrect\n\* `no-time-tickets` - No Time Tickets\n\* `required-hours-incorrect` - Required Hours Incorrect\n\* `miscellaneous-fees` - Miscellaneous Fees\n\* `covered-by-contract` - Covered By Contract\n\* `work-not-required` - Work Not Required\n\* `material-markup-incorrect` - Material Markup Incorrect\n\* `material-quantity-incorrect` - Material Quantity Incorrect\n\* `pre-negotiated-price-not-followed` - Pre-negotiated Price Not Followed\n\* `other` - Other')).nullish(),
  "description": zod.string().optional(),
  "region": zod.string().nullable(),
  "consultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(invoicesListResponseResultsItemOneConsultantOneUsernameMax).regex(invoicesListResponseResultsItemOneConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(invoicesListResponseResultsItemOneConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(invoicesListResponseResultsItemOneConsultantOnePhoneNumberMax).optional()
}).strict().nullable(),
  "proposedAmount": zod.string().regex(invoicesListResponseResultsItemOneProposedAmountRegExp).nullish(),
  "reviewedAmount": zod.string().regex(invoicesListResponseResultsItemOneReviewedAmountRegExp).nullish(),
  "approvedAmount": zod.string().regex(invoicesListResponseResultsItemOneApprovedAmountRegExp),
  "serviceProvider": zod.object({
  "name": zod.string().optional(),
  "id": zod.string().uuid().optional()
}).strict().nullable(),
  "date": zod.string().date().nullish(),
  "dateStamped": zod.string().datetime({"offset":true}).nullish(),
  "id": zod.string().uuid(),
  "carsServiced": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "ahjId": zod.string().optional(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish()
}).strict()),
  "lineItems": zod.array(zod.object({
  "id": zod.number(),
  "description": zod.string(),
  "amount": zod.string().regex(invoicesListResponseResultsItemOneLineItemsItemAmountRegExp)
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "property": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "address": zod.string().nullable(),
  "timeZone": zod.string().optional()
}).strict().nullable(),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesListResponseResultsItemOneAttachmentsItemPageNumberMin).max(invoicesListResponseResultsItemOneAttachmentsItemPageNumberMax).nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "addStampedReason": zod.boolean().optional(),
  "consultantGroup": zod.string().uuid().nullable(),
  "autoUpload": zod.boolean().optional(),
  "savings": zod.string().regex(invoicesListResponseResultsItemOneSavingsRegExp).nullish(),
  "tickets": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesListResponseResultsItemOneTicketsItemNumberMax),
  "property": zod.string().uuid().nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "relatedInvoices": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesListResponseResultsItemOneRelatedInvoicesItemNumberMax),
  "proposedAmount": zod.string().regex(invoicesListResponseResultsItemOneRelatedInvoicesItemProposedAmountRegExp).nullish(),
  "reviewedAmount": zod.string().regex(invoicesListResponseResultsItemOneRelatedInvoicesItemReviewedAmountRegExp).nullish(),
  "kind": zod.enum(['invoice', 'proposal', 'credit']).describe('\* `invoice` - Invoice\n\* `proposal` - Proposal\n\* `credit` - Credit'),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesListResponseResultsItemOneRelatedInvoicesItemAttachmentsItemPageNumberMin).max(invoicesListResponseResultsItemOneRelatedInvoicesItemAttachmentsItemPageNumberMax).nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])'))
}).strict()),
  "parentInvoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesListResponseResultsItemOneParentInvoiceOneNumberMax),
  "proposedAmount": zod.string().regex(invoicesListResponseResultsItemOneParentInvoiceOneProposedAmountRegExp).nullish()
}).strict().nullable(),
  "adjustmentSource": zod.union([zod.enum(['manual', 'agent']).describe('\* `manual` - Manual\n\* `agent` - Agent'),zod.enum(['']),zod.literal(null)]).nullish().describe('How the adjustment link was created: manually by consultant or automatically by agent.\n\n\* `manual` - Manual\n\* `agent` - Agent'),
  "adjustments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesListResponseResultsItemOneAdjustmentsItemNumberMax),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "proposedAmount": zod.string().regex(invoicesListResponseResultsItemOneAdjustmentsItemProposedAmountRegExp).nullish(),
  "adjustmentSource": zod.union([zod.enum(['manual', 'agent']).describe('\* `manual` - Manual\n\* `agent` - Agent'),zod.enum(['']),zod.literal(null)]).nullish().describe('How the adjustment link was created: manually by consultant or automatically by agent.\n\n\* `manual` - Manual\n\* `agent` - Agent'),
  "savingsDelta": zod.number().nullable()
}).strict()),
  "keepOnFileOnly": zod.boolean().optional(),
  "creditedInvoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesListResponseResultsItemOneCreditedInvoiceOneNumberMax),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "proposedAmount": zod.string().regex(invoicesListResponseResultsItemOneCreditedInvoiceOneProposedAmountRegExp).nullish(),
  "reviewedAmount": zod.string().regex(invoicesListResponseResultsItemOneCreditedInvoiceOneReviewedAmountRegExp).nullish(),
  "savings": zod.string().regex(invoicesListResponseResultsItemOneCreditedInvoiceOneSavingsRegExp).nullish(),
  "disputeSavings": zod.string().regex(invoicesListResponseResultsItemOneCreditedInvoiceOneDisputeSavingsRegExp).nullish()
}).strict().nullable(),
  "credits": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesListResponseResultsItemOneCreditsItemNumberMax),
  "date": zod.string().date().nullish(),
  "proposedAmount": zod.string().regex(invoicesListResponseResultsItemOneCreditsItemProposedAmountRegExp).nullish(),
  "keepOnFileOnly": zod.boolean().optional()
}).strict()),
  "countsTowardSpend": zod.boolean().nullable(),
  "stampFile": zod.string().url().nullable(),
  "insights": zod.unknown().nullable(),
  "insightStatus": zod.enum(['pending', 'processing', 'completed', 'failed']).describe('\* `pending` - Pending\n\* `processing` - Processing\n\* `completed` - Completed\n\* `failed` - Failed').optional().describe('Current status of insight generation\n\n\* `pending` - Pending\n\* `processing` - Processing\n\* `completed` - Completed\n\* `failed` - Failed'),
  "activeContractId": zod.string().uuid().nullable().describe('Id of the contract whose terms govern this invoice (by property + date\noverlap), or None when it can\'t be resolved. Powers the AI-vs-consultant\nrule-suggestion flow, which needs the contract to draft a review rule.\n\nResolved only for single-object (detail) responses — the rule-suggestion\nchat tool loops back to the invoice detail endpoint. Skipped during list\nserialization because find_active_property_contract issues per-invoice\nqueries the list queryset can\'t prefetch, which would N+1.'),
  "source": zod.string().nullable(),
  "emailContext": zod.object({
  "sender": zod.string(),
  "subject": zod.string(),
  "textBody": zod.string(),
  "receivedAt": zod.string().datetime({"offset":true})
}).strict().nullable(),
  "uploadedBy": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(invoicesListResponseResultsItemOneUploadedByOneUsernameMax).regex(invoicesListResponseResultsItemOneUploadedByOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(invoicesListResponseResultsItemOneUploadedByOneEmailMax).optional(),
  "phoneNumber": zod.string().max(invoicesListResponseResultsItemOneUploadedByOnePhoneNumberMax).optional()
}).strict().nullable(),
  "uploadedAt": zod.string().datetime({"offset":true}).nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "projectedSavings": zod.number().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])'),zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesListResponseResultsItemTwoNumberMax),
  "property": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "address": zod.string().nullable(),
  "timeZone": zod.string().optional()
}).strict().nullable(),
  "serviceProvider": zod.object({
  "name": zod.string().optional(),
  "id": zod.string().uuid().optional()
}).strict().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])'),zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesListResponseResultsItemThreeNumberMax),
  "kind": zod.enum(['invoice', 'proposal', 'credit']).describe('\* `invoice` - Invoice\n\* `proposal` - Proposal\n\* `credit` - Credit'),
  "type": zod.enum(['maintenance', 'modernization', 'callback', 'inspection', 'repair', 'fee']).describe('\* `maintenance` - Maintenance\n\* `modernization` - Modernization\n\* `callback` - Callback\n\* `inspection` - Inspection\n\* `repair` - Repair\n\* `fee` - Late Fee \/ Service Fee'),
  "date": zod.string().date().nullish(),
  "dateStamped": zod.string().datetime({"offset":true}).nullish(),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "disputeStatus": zod.enum(['none', 'active', 'awaiting-vendor', 'resolved', 'withdrawn']).optional().describe('\* `none` - None\n\* `active` - Active\n\* `awaiting-vendor` - Awaiting Vendor\n\* `resolved` - Resolved\n\* `withdrawn` - Withdrawn'),
  "disputeNeedsAttention": zod.boolean().describe('Returns True when the dispute is active and a vendor response\nhas been analyzed, indicating the consultant needs to take action.'),
  "property": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "address": zod.string().nullable(),
  "timeZone": zod.string().optional()
}).strict().nullable(),
  "region": zod.string().nullable(),
  "serviceProvider": zod.object({
  "name": zod.string().optional(),
  "id": zod.string().uuid().optional()
}).strict().nullable(),
  "consultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(invoicesListResponseResultsItemThreeConsultantOneUsernameMax).regex(invoicesListResponseResultsItemThreeConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(invoicesListResponseResultsItemThreeConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(invoicesListResponseResultsItemThreeConsultantOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultantGroup": zod.string().uuid().nullable(),
  "proposedAmount": zod.string().regex(invoicesListResponseResultsItemThreeProposedAmountRegExp).nullish(),
  "reviewedAmount": zod.string().regex(invoicesListResponseResultsItemThreeReviewedAmountRegExp).nullish(),
  "reason": zod.string().optional(),
  "rejectionCategory": zod.array(zod.enum(['billing-rate-incorrect', 'no-time-tickets', 'required-hours-incorrect', 'miscellaneous-fees', 'covered-by-contract', 'work-not-required', 'material-markup-incorrect', 'material-quantity-incorrect', 'pre-negotiated-price-not-followed', 'other']).describe('\* `billing-rate-incorrect` - Billing Rate Incorrect\n\* `no-time-tickets` - No Time Tickets\n\* `required-hours-incorrect` - Required Hours Incorrect\n\* `miscellaneous-fees` - Miscellaneous Fees\n\* `covered-by-contract` - Covered By Contract\n\* `work-not-required` - Work Not Required\n\* `material-markup-incorrect` - Material Markup Incorrect\n\* `material-quantity-incorrect` - Material Quantity Incorrect\n\* `pre-negotiated-price-not-followed` - Pre-negotiated Price Not Followed\n\* `other` - Other')).nullish(),
  "description": zod.string().optional(),
  "carsServiced": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "ahjId": zod.string().optional(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish()
}).strict()),
  "autoUpload": zod.boolean().optional(),
  "savings": zod.string().regex(invoicesListResponseResultsItemThreeSavingsRegExp).nullish(),
  "tickets": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesListResponseResultsItemThreeTicketsItemNumberMax),
  "property": zod.string().uuid().nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "relatedInvoices": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesListResponseResultsItemThreeRelatedInvoicesItemNumberMax),
  "proposedAmount": zod.string().regex(invoicesListResponseResultsItemThreeRelatedInvoicesItemProposedAmountRegExp).nullish(),
  "reviewedAmount": zod.string().regex(invoicesListResponseResultsItemThreeRelatedInvoicesItemReviewedAmountRegExp).nullish(),
  "kind": zod.enum(['invoice', 'proposal', 'credit']).describe('\* `invoice` - Invoice\n\* `proposal` - Proposal\n\* `credit` - Credit'),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesListResponseResultsItemThreeRelatedInvoicesItemAttachmentsItemPageNumberMin).max(invoicesListResponseResultsItemThreeRelatedInvoicesItemAttachmentsItemPageNumberMax).nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])'))
}).strict())
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')]))
}).strict()

/**
 * Basic API CRUD access to Invoice entities.
 */
export const invoicesCreateBodyNumberMax = 100;


export const invoicesCreateBodyLineItemsItemAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesCreateBodyProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesCreateBodyReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesCreateBodySavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');


export const InvoicesCreateBody = zod.object({
  "number": zod.string().min(1).max(invoicesCreateBodyNumberMax),
  "date": zod.string().date().optional(),
  "kind": zod.enum(['invoice', 'proposal', 'credit']).describe('\* `invoice` - Invoice\n\* `proposal` - Proposal\n\* `credit` - Credit'),
  "type": zod.enum(['maintenance', 'modernization', 'callback', 'inspection', 'repair', 'fee']).optional().describe('\* `maintenance` - Maintenance\n\* `modernization` - Modernization\n\* `callback` - Callback\n\* `inspection` - Inspection\n\* `repair` - Repair\n\* `fee` - Late Fee \/ Service Fee'),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "lineItems": zod.array(zod.object({
  "id": zod.number().optional(),
  "description": zod.string().min(1),
  "amount": zod.string().regex(invoicesCreateBodyLineItemsItemAmountRegExp)
})).optional(),
  "proposedAmount": zod.string().regex(invoicesCreateBodyProposedAmountRegExp).optional(),
  "reviewedAmount": zod.string().regex(invoicesCreateBodyReviewedAmountRegExp).nullish(),
  "savings": zod.string().regex(invoicesCreateBodySavingsRegExp).nullish(),
  "description": zod.string().optional(),
  "reason": zod.string().optional(),
  "dateStamped": zod.string().datetime({"offset":true}).nullish(),
  "propertyId": zod.string().uuid(),
  "consultantId": zod.string().uuid(),
  "serviceProviderId": zod.string().uuid().optional(),
  "carIds": zod.array(zod.string().uuid()).optional(),
  "addStampedReason": zod.boolean().optional(),
  "relatedInvoices": zod.array(zod.string().uuid()).optional(),
  "rejectionCategory": zod.array(zod.enum(['billing-rate-incorrect', 'no-time-tickets', 'required-hours-incorrect', 'miscellaneous-fees', 'covered-by-contract', 'work-not-required', 'material-markup-incorrect', 'material-quantity-incorrect', 'pre-negotiated-price-not-followed', 'other']).describe('\* `billing-rate-incorrect` - Billing Rate Incorrect\n\* `no-time-tickets` - No Time Tickets\n\* `required-hours-incorrect` - Required Hours Incorrect\n\* `miscellaneous-fees` - Miscellaneous Fees\n\* `covered-by-contract` - Covered By Contract\n\* `work-not-required` - Work Not Required\n\* `material-markup-incorrect` - Material Markup Incorrect\n\* `material-quantity-incorrect` - Material Quantity Incorrect\n\* `pre-negotiated-price-not-followed` - Pre-negotiated Price Not Followed\n\* `other` - Other')).nullish(),
  "parentInvoiceId": zod.string().uuid().nullish(),
  "creditedInvoiceId": zod.string().uuid().nullish(),
  "keepOnFileOnly": zod.boolean().optional()
})

export const invoicesCreateResponseNumberMax = 100;

export const invoicesCreateResponseConsultantOneUsernameMax = 150;


export const invoicesCreateResponseConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const invoicesCreateResponseConsultantOneEmailMax = 254;

export const invoicesCreateResponseConsultantOnePhoneNumberMax = 128;

export const invoicesCreateResponseProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesCreateResponseReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesCreateResponseApprovedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesCreateResponseLineItemsItemAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesCreateResponseAttachmentsItemPageNumberMin = 0;
export const invoicesCreateResponseAttachmentsItemPageNumberMax = 2147483647;

export const invoicesCreateResponseSavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesCreateResponseTicketsItemNumberMax = 20;

export const invoicesCreateResponseRelatedInvoicesItemNumberMax = 100;

export const invoicesCreateResponseRelatedInvoicesItemProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesCreateResponseRelatedInvoicesItemReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesCreateResponseRelatedInvoicesItemAttachmentsItemPageNumberMin = 0;
export const invoicesCreateResponseRelatedInvoicesItemAttachmentsItemPageNumberMax = 2147483647;

export const invoicesCreateResponseParentInvoiceOneNumberMax = 100;

export const invoicesCreateResponseParentInvoiceOneProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesCreateResponseAdjustmentsItemNumberMax = 100;

export const invoicesCreateResponseAdjustmentsItemProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesCreateResponseCreditedInvoiceOneNumberMax = 100;

export const invoicesCreateResponseCreditedInvoiceOneProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesCreateResponseCreditedInvoiceOneReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesCreateResponseCreditedInvoiceOneSavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesCreateResponseCreditedInvoiceOneDisputeSavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesCreateResponseCreditsItemNumberMax = 100;

export const invoicesCreateResponseCreditsItemProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesCreateResponseUploadedByOneUsernameMax = 150;


export const invoicesCreateResponseUploadedByOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const invoicesCreateResponseUploadedByOneEmailMax = 254;

export const invoicesCreateResponseUploadedByOnePhoneNumberMax = 128;



export const InvoicesCreateResponse = zod.object({
  "number": zod.string().max(invoicesCreateResponseNumberMax),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "disputeStatus": zod.enum(['none', 'active', 'awaiting-vendor', 'resolved', 'withdrawn']).optional().describe('\* `none` - None\n\* `active` - Active\n\* `awaiting-vendor` - Awaiting Vendor\n\* `resolved` - Resolved\n\* `withdrawn` - Withdrawn'),
  "disputeNeedsAttention": zod.boolean().describe('Returns True when the dispute is active and a vendor response\nhas been analyzed, indicating the consultant needs to take action.'),
  "type": zod.enum(['maintenance', 'modernization', 'callback', 'inspection', 'repair', 'fee']).describe('\* `maintenance` - Maintenance\n\* `modernization` - Modernization\n\* `callback` - Callback\n\* `inspection` - Inspection\n\* `repair` - Repair\n\* `fee` - Late Fee \/ Service Fee'),
  "kind": zod.enum(['invoice', 'proposal', 'credit']).describe('\* `invoice` - Invoice\n\* `proposal` - Proposal\n\* `credit` - Credit'),
  "reason": zod.string().optional(),
  "rejectionCategory": zod.array(zod.enum(['billing-rate-incorrect', 'no-time-tickets', 'required-hours-incorrect', 'miscellaneous-fees', 'covered-by-contract', 'work-not-required', 'material-markup-incorrect', 'material-quantity-incorrect', 'pre-negotiated-price-not-followed', 'other']).describe('\* `billing-rate-incorrect` - Billing Rate Incorrect\n\* `no-time-tickets` - No Time Tickets\n\* `required-hours-incorrect` - Required Hours Incorrect\n\* `miscellaneous-fees` - Miscellaneous Fees\n\* `covered-by-contract` - Covered By Contract\n\* `work-not-required` - Work Not Required\n\* `material-markup-incorrect` - Material Markup Incorrect\n\* `material-quantity-incorrect` - Material Quantity Incorrect\n\* `pre-negotiated-price-not-followed` - Pre-negotiated Price Not Followed\n\* `other` - Other')).nullish(),
  "description": zod.string().optional(),
  "region": zod.string().nullable(),
  "consultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(invoicesCreateResponseConsultantOneUsernameMax).regex(invoicesCreateResponseConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(invoicesCreateResponseConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(invoicesCreateResponseConsultantOnePhoneNumberMax).optional()
}).strict().nullable(),
  "proposedAmount": zod.string().regex(invoicesCreateResponseProposedAmountRegExp).nullish(),
  "reviewedAmount": zod.string().regex(invoicesCreateResponseReviewedAmountRegExp).nullish(),
  "approvedAmount": zod.string().regex(invoicesCreateResponseApprovedAmountRegExp),
  "serviceProvider": zod.object({
  "name": zod.string().optional(),
  "id": zod.string().uuid().optional()
}).strict().nullable(),
  "date": zod.string().date().nullish(),
  "dateStamped": zod.string().datetime({"offset":true}).nullish(),
  "id": zod.string().uuid(),
  "carsServiced": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "ahjId": zod.string().optional(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish()
}).strict()),
  "lineItems": zod.array(zod.object({
  "id": zod.number(),
  "description": zod.string(),
  "amount": zod.string().regex(invoicesCreateResponseLineItemsItemAmountRegExp)
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "property": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "address": zod.string().nullable(),
  "timeZone": zod.string().optional()
}).strict().nullable(),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesCreateResponseAttachmentsItemPageNumberMin).max(invoicesCreateResponseAttachmentsItemPageNumberMax).nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "addStampedReason": zod.boolean().optional(),
  "consultantGroup": zod.string().uuid().nullable(),
  "autoUpload": zod.boolean().optional(),
  "savings": zod.string().regex(invoicesCreateResponseSavingsRegExp).nullish(),
  "tickets": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesCreateResponseTicketsItemNumberMax),
  "property": zod.string().uuid().nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "relatedInvoices": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesCreateResponseRelatedInvoicesItemNumberMax),
  "proposedAmount": zod.string().regex(invoicesCreateResponseRelatedInvoicesItemProposedAmountRegExp).nullish(),
  "reviewedAmount": zod.string().regex(invoicesCreateResponseRelatedInvoicesItemReviewedAmountRegExp).nullish(),
  "kind": zod.enum(['invoice', 'proposal', 'credit']).describe('\* `invoice` - Invoice\n\* `proposal` - Proposal\n\* `credit` - Credit'),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesCreateResponseRelatedInvoicesItemAttachmentsItemPageNumberMin).max(invoicesCreateResponseRelatedInvoicesItemAttachmentsItemPageNumberMax).nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])'))
}).strict()),
  "parentInvoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesCreateResponseParentInvoiceOneNumberMax),
  "proposedAmount": zod.string().regex(invoicesCreateResponseParentInvoiceOneProposedAmountRegExp).nullish()
}).strict().nullable(),
  "adjustmentSource": zod.union([zod.enum(['manual', 'agent']).describe('\* `manual` - Manual\n\* `agent` - Agent'),zod.enum(['']),zod.literal(null)]).nullish().describe('How the adjustment link was created: manually by consultant or automatically by agent.\n\n\* `manual` - Manual\n\* `agent` - Agent'),
  "adjustments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesCreateResponseAdjustmentsItemNumberMax),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "proposedAmount": zod.string().regex(invoicesCreateResponseAdjustmentsItemProposedAmountRegExp).nullish(),
  "adjustmentSource": zod.union([zod.enum(['manual', 'agent']).describe('\* `manual` - Manual\n\* `agent` - Agent'),zod.enum(['']),zod.literal(null)]).nullish().describe('How the adjustment link was created: manually by consultant or automatically by agent.\n\n\* `manual` - Manual\n\* `agent` - Agent'),
  "savingsDelta": zod.number().nullable()
}).strict()),
  "keepOnFileOnly": zod.boolean().optional(),
  "creditedInvoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesCreateResponseCreditedInvoiceOneNumberMax),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "proposedAmount": zod.string().regex(invoicesCreateResponseCreditedInvoiceOneProposedAmountRegExp).nullish(),
  "reviewedAmount": zod.string().regex(invoicesCreateResponseCreditedInvoiceOneReviewedAmountRegExp).nullish(),
  "savings": zod.string().regex(invoicesCreateResponseCreditedInvoiceOneSavingsRegExp).nullish(),
  "disputeSavings": zod.string().regex(invoicesCreateResponseCreditedInvoiceOneDisputeSavingsRegExp).nullish()
}).strict().nullable(),
  "credits": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesCreateResponseCreditsItemNumberMax),
  "date": zod.string().date().nullish(),
  "proposedAmount": zod.string().regex(invoicesCreateResponseCreditsItemProposedAmountRegExp).nullish(),
  "keepOnFileOnly": zod.boolean().optional()
}).strict()),
  "countsTowardSpend": zod.boolean().nullable(),
  "stampFile": zod.string().url().nullable(),
  "insights": zod.unknown().nullable(),
  "insightStatus": zod.enum(['pending', 'processing', 'completed', 'failed']).describe('\* `pending` - Pending\n\* `processing` - Processing\n\* `completed` - Completed\n\* `failed` - Failed').optional().describe('Current status of insight generation\n\n\* `pending` - Pending\n\* `processing` - Processing\n\* `completed` - Completed\n\* `failed` - Failed'),
  "activeContractId": zod.string().uuid().nullable().describe('Id of the contract whose terms govern this invoice (by property + date\noverlap), or None when it can\'t be resolved. Powers the AI-vs-consultant\nrule-suggestion flow, which needs the contract to draft a review rule.\n\nResolved only for single-object (detail) responses — the rule-suggestion\nchat tool loops back to the invoice detail endpoint. Skipped during list\nserialization because find_active_property_contract issues per-invoice\nqueries the list queryset can\'t prefetch, which would N+1.'),
  "source": zod.string().nullable(),
  "emailContext": zod.object({
  "sender": zod.string(),
  "subject": zod.string(),
  "textBody": zod.string(),
  "receivedAt": zod.string().datetime({"offset":true})
}).strict().nullable(),
  "uploadedBy": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(invoicesCreateResponseUploadedByOneUsernameMax).regex(invoicesCreateResponseUploadedByOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(invoicesCreateResponseUploadedByOneEmailMax).optional(),
  "phoneNumber": zod.string().max(invoicesCreateResponseUploadedByOnePhoneNumberMax).optional()
}).strict().nullable(),
  "uploadedAt": zod.string().datetime({"offset":true}).nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "projectedSavings": zod.number().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * GET /api/v1/invoices/{id}/adjustments/ — list all adjustments.
 */
export const InvoicesAdjustmentsListParams = zod.object({
  "invoicePk": zod.string().uuid().describe('UUID of the parent (original) invoice.')
})

export const invoicesAdjustmentsListResponseNumberMax = 100;

export const invoicesAdjustmentsListResponseProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');


export const InvoicesAdjustmentsListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesAdjustmentsListResponseNumberMax),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "proposedAmount": zod.string().regex(invoicesAdjustmentsListResponseProposedAmountRegExp).nullish(),
  "adjustmentSource": zod.union([zod.enum(['manual', 'agent']).describe('\* `manual` - Manual\n\* `agent` - Agent'),zod.enum(['']),zod.literal(null)]).nullish().describe('How the adjustment link was created: manually by consultant or automatically by agent.\n\n\* `manual` - Manual\n\* `agent` - Agent'),
  "savingsDelta": zod.number().nullable()
}).strict()
export const InvoicesAdjustmentsListResponse = zod.array(InvoicesAdjustmentsListResponseItem)

/**
 * POST /api/v1/invoices/{id}/adjustments/link/{adj_id}/ — link existing invoice as adjustment.
 */
export const invoicesAdjustmentsLinkCreatePathAdjustmentIdRegExp = new RegExp('^[0-9a-f-]+$');


export const InvoicesAdjustmentsLinkCreateParams = zod.object({
  "adjustmentId": zod.string().regex(invoicesAdjustmentsLinkCreatePathAdjustmentIdRegExp),
  "invoicePk": zod.string().uuid().describe('UUID of the parent (original) invoice.')
})

export const invoicesAdjustmentsLinkCreateResponseNumberMax = 100;

export const invoicesAdjustmentsLinkCreateResponseProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');


export const InvoicesAdjustmentsLinkCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesAdjustmentsLinkCreateResponseNumberMax),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "proposedAmount": zod.string().regex(invoicesAdjustmentsLinkCreateResponseProposedAmountRegExp).nullish(),
  "adjustmentSource": zod.union([zod.enum(['manual', 'agent']).describe('\* `manual` - Manual\n\* `agent` - Agent'),zod.enum(['']),zod.literal(null)]).nullish().describe('How the adjustment link was created: manually by consultant or automatically by agent.\n\n\* `manual` - Manual\n\* `agent` - Agent'),
  "savingsDelta": zod.number().nullable()
}).strict()

/**
 * POST /api/v1/invoices/{id}/adjustments/unlink/{adj_id}/ — remove adjustment link.
 */
export const invoicesAdjustmentsUnlinkCreatePathAdjustmentIdRegExp = new RegExp('^[0-9a-f-]+$');


export const InvoicesAdjustmentsUnlinkCreateParams = zod.object({
  "adjustmentId": zod.string().regex(invoicesAdjustmentsUnlinkCreatePathAdjustmentIdRegExp),
  "invoicePk": zod.string().uuid().describe('UUID of the parent (original) invoice.')
})

export const InvoicesAdjustmentsUnlinkCreateResponse = zod.void()

export const InvoicesAttachmentsListParams = zod.object({
  "invoicePk": zod.string().uuid()
})

export const invoicesAttachmentsListResponsePageNumberMin = 0;
export const invoicesAttachmentsListResponsePageNumberMax = 2147483647;



export const InvoicesAttachmentsListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "invoice": zod.string().uuid(),
  "attachment": zod.string().uuid(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesAttachmentsListResponsePageNumberMin).max(invoicesAttachmentsListResponsePageNumberMax).nullish()
}).strict().describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')
export const InvoicesAttachmentsListResponse = zod.array(InvoicesAttachmentsListResponseItem)

export const InvoicesAttachmentsCreateParams = zod.object({
  "invoicePk": zod.string().uuid()
})

export const invoicesAttachmentsCreateBodyPageNumberMin = 0;
export const invoicesAttachmentsCreateBodyPageNumberMax = 2147483647;



export const InvoicesAttachmentsCreateBody = zod.object({
  "invoice": zod.string().uuid(),
  "attachment": zod.string().uuid(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesAttachmentsCreateBodyPageNumberMin).max(invoicesAttachmentsCreateBodyPageNumberMax).nullish()
}).describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')

export const invoicesAttachmentsCreateResponsePageNumberMin = 0;
export const invoicesAttachmentsCreateResponsePageNumberMax = 2147483647;



export const InvoicesAttachmentsCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "invoice": zod.string().uuid(),
  "attachment": zod.string().uuid(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesAttachmentsCreateResponsePageNumberMin).max(invoicesAttachmentsCreateResponsePageNumberMax).nullish()
}).strict().describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')

export const InvoicesAttachmentsRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this invoice attachment.'),
  "invoicePk": zod.string().uuid()
})

export const invoicesAttachmentsRetrieveResponsePageNumberMin = 0;
export const invoicesAttachmentsRetrieveResponsePageNumberMax = 2147483647;



export const InvoicesAttachmentsRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "invoice": zod.string().uuid(),
  "attachment": zod.string().uuid(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesAttachmentsRetrieveResponsePageNumberMin).max(invoicesAttachmentsRetrieveResponsePageNumberMax).nullish()
}).strict().describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')

export const InvoicesAttachmentsUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this invoice attachment.'),
  "invoicePk": zod.string().uuid()
})

export const invoicesAttachmentsUpdateBodyPageNumberMin = 0;
export const invoicesAttachmentsUpdateBodyPageNumberMax = 2147483647;



export const InvoicesAttachmentsUpdateBody = zod.object({
  "invoice": zod.string().uuid(),
  "attachment": zod.string().uuid(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesAttachmentsUpdateBodyPageNumberMin).max(invoicesAttachmentsUpdateBodyPageNumberMax).nullish()
}).describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')

export const invoicesAttachmentsUpdateResponsePageNumberMin = 0;
export const invoicesAttachmentsUpdateResponsePageNumberMax = 2147483647;



export const InvoicesAttachmentsUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "invoice": zod.string().uuid(),
  "attachment": zod.string().uuid(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesAttachmentsUpdateResponsePageNumberMin).max(invoicesAttachmentsUpdateResponsePageNumberMax).nullish()
}).strict().describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')

export const InvoicesAttachmentsPartialUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this invoice attachment.'),
  "invoicePk": zod.string().uuid()
})

export const invoicesAttachmentsPartialUpdateBodyPageNumberMin = 0;
export const invoicesAttachmentsPartialUpdateBodyPageNumberMax = 2147483647;



export const InvoicesAttachmentsPartialUpdateBody = zod.object({
  "invoice": zod.string().uuid().optional(),
  "attachment": zod.string().uuid().optional(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesAttachmentsPartialUpdateBodyPageNumberMin).max(invoicesAttachmentsPartialUpdateBodyPageNumberMax).nullish()
}).describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')

export const invoicesAttachmentsPartialUpdateResponsePageNumberMin = 0;
export const invoicesAttachmentsPartialUpdateResponsePageNumberMax = 2147483647;



export const InvoicesAttachmentsPartialUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "invoice": zod.string().uuid(),
  "attachment": zod.string().uuid(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesAttachmentsPartialUpdateResponsePageNumberMin).max(invoicesAttachmentsPartialUpdateResponsePageNumberMax).nullish()
}).strict().describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')

export const InvoicesAttachmentsDestroyParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this invoice attachment.'),
  "invoicePk": zod.string().uuid()
})

export const InvoicesAttachmentsDestroyResponse = zod.void()

/**
 * Full dispute agent state for the invoice.
 */
export const InvoicesDisputeRetrieveParams = zod.object({
  "invoicePk": zod.string().uuid().describe('UUID of the parent invoice.')
})

export const InvoicesDisputeRetrieveResponse = zod.object({
  "invoiceId": zod.string(),
  "status": zod.enum(['none', 'active', 'awaiting-vendor', 'resolved', 'withdrawn']).describe('\* `none` - None\n\* `active` - Active\n\* `awaiting-vendor` - Awaiting Vendor\n\* `resolved` - Resolved\n\* `withdrawn` - Withdrawn'),
  "initiatedAt": zod.string().datetime({"offset":true}).nullable(),
  "vendorPosition": zod.string().nullable(),
  "followUpCount": zod.number(),
  "maxFollowUps": zod.number(),
  "nextFollowUpDate": zod.string().datetime({"offset":true}).nullable(),
  "daysSinceLastContact": zod.number(),
  "resolution": zod.object({
  "resolutionType": zod.string(),
  "settledAmount": zod.string(),
  "savings": zod.string(),
  "notes": zod.string()
}).strict().nullable(),
  "suggestedActions": zod.array(zod.object({
  "action": zod.string(),
  "label": zod.string(),
  "reason": zod.string(),
  "priority": zod.enum(['primary', 'secondary', 'overflow']).describe('\* `primary` - primary\n\* `secondary` - secondary\n\* `overflow` - overflow'),
  "payload": zod.record(zod.string(), zod.unknown()).nullish()
}).strict().describe('An agent-suggested next action, embedded in the dispute state.')),
  "attentionReason": zod.string(),
  "currentDraft": zod.object({
  "draftType": zod.enum(['dispute', 'data_request', 'follow_up']).describe('\* `dispute` - Dispute\n\* `data_request` - Data Request\n\* `follow_up` - Follow Up'),
  "fromEmail": zod.string().optional().describe('Read-only; configured in the Email Integration Platform.'),
  "subject": zod.string(),
  "body": zod.string(),
  "to": zod.array(zod.string()),
  "cc": zod.array(zod.string()),
  "isAgentGenerated": zod.boolean(),
  "basedOnFindings": zod.boolean(),
  "attachments": zod.array(zod.object({
  "id": zod.string(),
  "filename": zod.string(),
  "fileType": zod.string().describe('e.g. \'pdf\' or \'image\'.'),
  "url": zod.string().nullable()
}).strict().describe('An attachment as embedded in a draft or timeline entry.')).optional(),
  "attachmentIds": zod.array(zod.string()).optional()
}).strict().nullable()
}).strict().describe('Full dispute agent state for an invoice (GET ...\/dispute\/).')

/**
 * Actions currently available for the dispute.
 */
export const InvoicesDisputeActionsListParams = zod.object({
  "invoicePk": zod.string().uuid().describe('UUID of the parent invoice.')
})

export const InvoicesDisputeActionsListResponseItem = zod.object({
  "action": zod.string(),
  "label": zod.string(),
  "priority": zod.enum(['primary', 'secondary', 'overflow']).describe('\* `primary` - primary\n\* `secondary` - secondary\n\* `overflow` - overflow')
}).strict().describe('An action the user can currently take (GET ...\/dispute\/actions\/).')
export const InvoicesDisputeActionsListResponse = zod.array(InvoicesDisputeActionsListResponseItem)

/**
 * POST /api/v1/invoices/{id}/dispute/categorize/
 */
export const InvoicesDisputeCategorizeCreateParams = zod.object({
  "invoicePk": zod.string().uuid().describe('UUID of the parent invoice.')
})

export const invoicesDisputeCategorizeCreateBodyVendorClaimedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');


export const InvoicesDisputeCategorizeCreateBody = zod.object({
  "timelineEntryId": zod.string().uuid(),
  "vendorPosition": zod.enum(['agreed', 'partial-agreement', 'disagreed-with-evidence', 'disagreed-without-evidence', 'requested-more-info']).describe('\* `agreed` - Agreed\n\* `partial-agreement` - Partial Agreement\n\* `disagreed-with-evidence` - Disagreed with Evidence\n\* `disagreed-without-evidence` - Disagreed without Evidence\n\* `requested-more-info` - Requested More Info'),
  "vendorClaimedAmount": zod.string().regex(invoicesDisputeCategorizeCreateBodyVendorClaimedAmountRegExp).nullish()
})

export const InvoicesDisputeCategorizeCreateResponse = zod.object({
  "invoiceId": zod.string(),
  "status": zod.enum(['none', 'active', 'awaiting-vendor', 'resolved', 'withdrawn']).describe('\* `none` - None\n\* `active` - Active\n\* `awaiting-vendor` - Awaiting Vendor\n\* `resolved` - Resolved\n\* `withdrawn` - Withdrawn'),
  "initiatedAt": zod.string().datetime({"offset":true}).nullable(),
  "vendorPosition": zod.string().nullable(),
  "followUpCount": zod.number(),
  "maxFollowUps": zod.number(),
  "nextFollowUpDate": zod.string().datetime({"offset":true}).nullable(),
  "daysSinceLastContact": zod.number(),
  "resolution": zod.object({
  "resolutionType": zod.string(),
  "settledAmount": zod.string(),
  "savings": zod.string(),
  "notes": zod.string()
}).strict().nullable(),
  "suggestedActions": zod.array(zod.object({
  "action": zod.string(),
  "label": zod.string(),
  "reason": zod.string(),
  "priority": zod.enum(['primary', 'secondary', 'overflow']).describe('\* `primary` - primary\n\* `secondary` - secondary\n\* `overflow` - overflow'),
  "payload": zod.record(zod.string(), zod.unknown()).nullish()
}).strict().describe('An agent-suggested next action, embedded in the dispute state.')),
  "attentionReason": zod.string(),
  "currentDraft": zod.object({
  "draftType": zod.enum(['dispute', 'data_request', 'follow_up']).describe('\* `dispute` - Dispute\n\* `data_request` - Data Request\n\* `follow_up` - Follow Up'),
  "fromEmail": zod.string().optional().describe('Read-only; configured in the Email Integration Platform.'),
  "subject": zod.string(),
  "body": zod.string(),
  "to": zod.array(zod.string()),
  "cc": zod.array(zod.string()),
  "isAgentGenerated": zod.boolean(),
  "basedOnFindings": zod.boolean(),
  "attachments": zod.array(zod.object({
  "id": zod.string(),
  "filename": zod.string(),
  "fileType": zod.string().describe('e.g. \'pdf\' or \'image\'.'),
  "url": zod.string().nullable()
}).strict().describe('An attachment as embedded in a draft or timeline entry.')).optional(),
  "attachmentIds": zod.array(zod.string()).optional()
}).strict().nullable()
}).strict().describe('Full dispute agent state for an invoice (GET ...\/dispute\/).')

/**
 * Get the current dispute draft.
 */
export const InvoicesDisputeDraftRetrieveParams = zod.object({
  "invoicePk": zod.string().uuid().describe('UUID of the parent invoice.')
})

export const InvoicesDisputeDraftRetrieveResponse = zod.object({
  "draftType": zod.enum(['dispute', 'data_request', 'follow_up']).describe('\* `dispute` - Dispute\n\* `data_request` - Data Request\n\* `follow_up` - Follow Up'),
  "fromEmail": zod.string().optional().describe('Read-only; configured in the Email Integration Platform.'),
  "subject": zod.string(),
  "body": zod.string(),
  "to": zod.array(zod.string()),
  "cc": zod.array(zod.string()),
  "isAgentGenerated": zod.boolean(),
  "basedOnFindings": zod.boolean(),
  "attachments": zod.array(zod.object({
  "id": zod.string(),
  "filename": zod.string(),
  "fileType": zod.string().describe('e.g. \'pdf\' or \'image\'.'),
  "url": zod.string().nullable()
}).strict().describe('An attachment as embedded in a draft or timeline entry.')).optional(),
  "attachmentIds": zod.array(zod.string()).optional()
}).strict().describe('An unsent dispute email draft.')

/**
 * Update the current dispute draft.
 */
export const InvoicesDisputeDraftUpdateParams = zod.object({
  "invoicePk": zod.string().uuid().describe('UUID of the parent invoice.')
})







export const InvoicesDisputeDraftUpdateBody = zod.object({
  "subject": zod.string().min(1).optional(),
  "body": zod.string().min(1).optional(),
  "to": zod.array(zod.string().email().min(1)).optional(),
  "cc": zod.array(zod.string().email().min(1)).optional(),
  "attachmentIds": zod.array(zod.string().uuid()).optional().describe('List of Attachment IDs to include with the email')
})

export const InvoicesDisputeDraftUpdateResponse = zod.object({
  "draftType": zod.enum(['dispute', 'data_request', 'follow_up']).describe('\* `dispute` - Dispute\n\* `data_request` - Data Request\n\* `follow_up` - Follow Up'),
  "fromEmail": zod.string().optional().describe('Read-only; configured in the Email Integration Platform.'),
  "subject": zod.string(),
  "body": zod.string(),
  "to": zod.array(zod.string()),
  "cc": zod.array(zod.string()),
  "isAgentGenerated": zod.boolean(),
  "basedOnFindings": zod.boolean(),
  "attachments": zod.array(zod.object({
  "id": zod.string(),
  "filename": zod.string(),
  "fileType": zod.string().describe('e.g. \'pdf\' or \'image\'.'),
  "url": zod.string().nullable()
}).strict().describe('An attachment as embedded in a draft or timeline entry.')).optional(),
  "attachmentIds": zod.array(zod.string()).optional()
}).strict().describe('An unsent dispute email draft.')

/**
 * Discard the current dispute draft; returns updated state.
 */
export const InvoicesDisputeDraftDestroyParams = zod.object({
  "invoicePk": zod.string().uuid().describe('UUID of the parent invoice.')
})

export const InvoicesDisputeDraftDestroyResponse = zod.object({
  "invoiceId": zod.string(),
  "status": zod.enum(['none', 'active', 'awaiting-vendor', 'resolved', 'withdrawn']).describe('\* `none` - None\n\* `active` - Active\n\* `awaiting-vendor` - Awaiting Vendor\n\* `resolved` - Resolved\n\* `withdrawn` - Withdrawn'),
  "initiatedAt": zod.string().datetime({"offset":true}).nullable(),
  "vendorPosition": zod.string().nullable(),
  "followUpCount": zod.number(),
  "maxFollowUps": zod.number(),
  "nextFollowUpDate": zod.string().datetime({"offset":true}).nullable(),
  "daysSinceLastContact": zod.number(),
  "resolution": zod.object({
  "resolutionType": zod.string(),
  "settledAmount": zod.string(),
  "savings": zod.string(),
  "notes": zod.string()
}).strict().nullable(),
  "suggestedActions": zod.array(zod.object({
  "action": zod.string(),
  "label": zod.string(),
  "reason": zod.string(),
  "priority": zod.enum(['primary', 'secondary', 'overflow']).describe('\* `primary` - primary\n\* `secondary` - secondary\n\* `overflow` - overflow'),
  "payload": zod.record(zod.string(), zod.unknown()).nullish()
}).strict().describe('An agent-suggested next action, embedded in the dispute state.')),
  "attentionReason": zod.string(),
  "currentDraft": zod.object({
  "draftType": zod.enum(['dispute', 'data_request', 'follow_up']).describe('\* `dispute` - Dispute\n\* `data_request` - Data Request\n\* `follow_up` - Follow Up'),
  "fromEmail": zod.string().optional().describe('Read-only; configured in the Email Integration Platform.'),
  "subject": zod.string(),
  "body": zod.string(),
  "to": zod.array(zod.string()),
  "cc": zod.array(zod.string()),
  "isAgentGenerated": zod.boolean(),
  "basedOnFindings": zod.boolean(),
  "attachments": zod.array(zod.object({
  "id": zod.string(),
  "filename": zod.string(),
  "fileType": zod.string().describe('e.g. \'pdf\' or \'image\'.'),
  "url": zod.string().nullable()
}).strict().describe('An attachment as embedded in a draft or timeline entry.')).optional(),
  "attachmentIds": zod.array(zod.string()).optional()
}).strict().nullable()
}).strict().describe('Full dispute agent state for an invoice (GET ...\/dispute\/).')

/**
 * POST /api/v1/invoices/{id}/dispute/generate-draft/
 */
export const InvoicesDisputeGenerateDraftCreateParams = zod.object({
  "invoicePk": zod.string().uuid().describe('UUID of the parent invoice.')
})

export const InvoicesDisputeGenerateDraftCreateBody = zod.object({
  "draftType": zod.enum(['dispute', 'data_request', 'follow_up']).describe('\* `dispute` - Dispute\n\* `data_request` - Data Request\n\* `follow_up` - Follow Up')
})

export const InvoicesDisputeGenerateDraftCreateResponse = zod.object({
  "draftType": zod.enum(['dispute', 'data_request', 'follow_up']).describe('\* `dispute` - Dispute\n\* `data_request` - Data Request\n\* `follow_up` - Follow Up'),
  "fromEmail": zod.string().optional().describe('Read-only; configured in the Email Integration Platform.'),
  "subject": zod.string(),
  "body": zod.string(),
  "to": zod.array(zod.string()),
  "cc": zod.array(zod.string()),
  "isAgentGenerated": zod.boolean(),
  "basedOnFindings": zod.boolean(),
  "attachments": zod.array(zod.object({
  "id": zod.string(),
  "filename": zod.string(),
  "fileType": zod.string().describe('e.g. \'pdf\' or \'image\'.'),
  "url": zod.string().nullable()
}).strict().describe('An attachment as embedded in a draft or timeline entry.')).optional(),
  "attachmentIds": zod.array(zod.string()).optional()
}).strict().describe('An unsent dispute email draft.')

/**
 * POST /api/v1/invoices/{id}/dispute/initiate/
 */
export const InvoicesDisputeInitiateCreateParams = zod.object({
  "invoicePk": zod.string().uuid().describe('UUID of the parent invoice.')
})

export const InvoicesDisputeInitiateCreateResponse = zod.object({
  "invoiceId": zod.string(),
  "status": zod.enum(['none', 'active', 'awaiting-vendor', 'resolved', 'withdrawn']).describe('\* `none` - None\n\* `active` - Active\n\* `awaiting-vendor` - Awaiting Vendor\n\* `resolved` - Resolved\n\* `withdrawn` - Withdrawn'),
  "initiatedAt": zod.string().datetime({"offset":true}).nullable(),
  "vendorPosition": zod.string().nullable(),
  "followUpCount": zod.number(),
  "maxFollowUps": zod.number(),
  "nextFollowUpDate": zod.string().datetime({"offset":true}).nullable(),
  "daysSinceLastContact": zod.number(),
  "resolution": zod.object({
  "resolutionType": zod.string(),
  "settledAmount": zod.string(),
  "savings": zod.string(),
  "notes": zod.string()
}).strict().nullable(),
  "suggestedActions": zod.array(zod.object({
  "action": zod.string(),
  "label": zod.string(),
  "reason": zod.string(),
  "priority": zod.enum(['primary', 'secondary', 'overflow']).describe('\* `primary` - primary\n\* `secondary` - secondary\n\* `overflow` - overflow'),
  "payload": zod.record(zod.string(), zod.unknown()).nullish()
}).strict().describe('An agent-suggested next action, embedded in the dispute state.')),
  "attentionReason": zod.string(),
  "currentDraft": zod.object({
  "draftType": zod.enum(['dispute', 'data_request', 'follow_up']).describe('\* `dispute` - Dispute\n\* `data_request` - Data Request\n\* `follow_up` - Follow Up'),
  "fromEmail": zod.string().optional().describe('Read-only; configured in the Email Integration Platform.'),
  "subject": zod.string(),
  "body": zod.string(),
  "to": zod.array(zod.string()),
  "cc": zod.array(zod.string()),
  "isAgentGenerated": zod.boolean(),
  "basedOnFindings": zod.boolean(),
  "attachments": zod.array(zod.object({
  "id": zod.string(),
  "filename": zod.string(),
  "fileType": zod.string().describe('e.g. \'pdf\' or \'image\'.'),
  "url": zod.string().nullable()
}).strict().describe('An attachment as embedded in a draft or timeline entry.')).optional(),
  "attachmentIds": zod.array(zod.string()).optional()
}).strict().nullable()
}).strict().describe('Full dispute agent state for an invoice (GET ...\/dispute\/).')

/**
 * POST /api/v1/invoices/{id}/dispute/reopen/
 */
export const InvoicesDisputeReopenCreateParams = zod.object({
  "invoicePk": zod.string().uuid().describe('UUID of the parent invoice.')
})

export const InvoicesDisputeReopenCreateResponse = zod.object({
  "invoiceId": zod.string(),
  "status": zod.enum(['none', 'active', 'awaiting-vendor', 'resolved', 'withdrawn']).describe('\* `none` - None\n\* `active` - Active\n\* `awaiting-vendor` - Awaiting Vendor\n\* `resolved` - Resolved\n\* `withdrawn` - Withdrawn'),
  "initiatedAt": zod.string().datetime({"offset":true}).nullable(),
  "vendorPosition": zod.string().nullable(),
  "followUpCount": zod.number(),
  "maxFollowUps": zod.number(),
  "nextFollowUpDate": zod.string().datetime({"offset":true}).nullable(),
  "daysSinceLastContact": zod.number(),
  "resolution": zod.object({
  "resolutionType": zod.string(),
  "settledAmount": zod.string(),
  "savings": zod.string(),
  "notes": zod.string()
}).strict().nullable(),
  "suggestedActions": zod.array(zod.object({
  "action": zod.string(),
  "label": zod.string(),
  "reason": zod.string(),
  "priority": zod.enum(['primary', 'secondary', 'overflow']).describe('\* `primary` - primary\n\* `secondary` - secondary\n\* `overflow` - overflow'),
  "payload": zod.record(zod.string(), zod.unknown()).nullish()
}).strict().describe('An agent-suggested next action, embedded in the dispute state.')),
  "attentionReason": zod.string(),
  "currentDraft": zod.object({
  "draftType": zod.enum(['dispute', 'data_request', 'follow_up']).describe('\* `dispute` - Dispute\n\* `data_request` - Data Request\n\* `follow_up` - Follow Up'),
  "fromEmail": zod.string().optional().describe('Read-only; configured in the Email Integration Platform.'),
  "subject": zod.string(),
  "body": zod.string(),
  "to": zod.array(zod.string()),
  "cc": zod.array(zod.string()),
  "isAgentGenerated": zod.boolean(),
  "basedOnFindings": zod.boolean(),
  "attachments": zod.array(zod.object({
  "id": zod.string(),
  "filename": zod.string(),
  "fileType": zod.string().describe('e.g. \'pdf\' or \'image\'.'),
  "url": zod.string().nullable()
}).strict().describe('An attachment as embedded in a draft or timeline entry.')).optional(),
  "attachmentIds": zod.array(zod.string()).optional()
}).strict().nullable()
}).strict().describe('Full dispute agent state for an invoice (GET ...\/dispute\/).')

/**
 * POST /api/v1/invoices/{id}/dispute/resolve/
 */
export const InvoicesDisputeResolveCreateParams = zod.object({
  "invoicePk": zod.string().uuid().describe('UUID of the parent invoice.')
})

export const invoicesDisputeResolveCreateBodySettledAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesDisputeResolveCreateBodyNotesDefault = ``;

export const InvoicesDisputeResolveCreateBody = zod.object({
  "resolutionType": zod.enum(['credit-issued', 'adjusted-invoice-received', 'vendor-rejected', 'withdrawn', 'other']).describe('\* `credit-issued` - Credit Issued\n\* `adjusted-invoice-received` - Adjusted Invoice Received\n\* `vendor-rejected` - Vendor Rejected\n\* `withdrawn` - Withdrawn\n\* `other` - Other'),
  "settledAmount": zod.string().regex(invoicesDisputeResolveCreateBodySettledAmountRegExp),
  "notes": zod.string().default(invoicesDisputeResolveCreateBodyNotesDefault)
})

export const InvoicesDisputeResolveCreateResponse = zod.object({
  "invoiceId": zod.string(),
  "status": zod.enum(['none', 'active', 'awaiting-vendor', 'resolved', 'withdrawn']).describe('\* `none` - None\n\* `active` - Active\n\* `awaiting-vendor` - Awaiting Vendor\n\* `resolved` - Resolved\n\* `withdrawn` - Withdrawn'),
  "initiatedAt": zod.string().datetime({"offset":true}).nullable(),
  "vendorPosition": zod.string().nullable(),
  "followUpCount": zod.number(),
  "maxFollowUps": zod.number(),
  "nextFollowUpDate": zod.string().datetime({"offset":true}).nullable(),
  "daysSinceLastContact": zod.number(),
  "resolution": zod.object({
  "resolutionType": zod.string(),
  "settledAmount": zod.string(),
  "savings": zod.string(),
  "notes": zod.string()
}).strict().nullable(),
  "suggestedActions": zod.array(zod.object({
  "action": zod.string(),
  "label": zod.string(),
  "reason": zod.string(),
  "priority": zod.enum(['primary', 'secondary', 'overflow']).describe('\* `primary` - primary\n\* `secondary` - secondary\n\* `overflow` - overflow'),
  "payload": zod.record(zod.string(), zod.unknown()).nullish()
}).strict().describe('An agent-suggested next action, embedded in the dispute state.')),
  "attentionReason": zod.string(),
  "currentDraft": zod.object({
  "draftType": zod.enum(['dispute', 'data_request', 'follow_up']).describe('\* `dispute` - Dispute\n\* `data_request` - Data Request\n\* `follow_up` - Follow Up'),
  "fromEmail": zod.string().optional().describe('Read-only; configured in the Email Integration Platform.'),
  "subject": zod.string(),
  "body": zod.string(),
  "to": zod.array(zod.string()),
  "cc": zod.array(zod.string()),
  "isAgentGenerated": zod.boolean(),
  "basedOnFindings": zod.boolean(),
  "attachments": zod.array(zod.object({
  "id": zod.string(),
  "filename": zod.string(),
  "fileType": zod.string().describe('e.g. \'pdf\' or \'image\'.'),
  "url": zod.string().nullable()
}).strict().describe('An attachment as embedded in a draft or timeline entry.')).optional(),
  "attachmentIds": zod.array(zod.string()).optional()
}).strict().nullable()
}).strict().describe('Full dispute agent state for an invoice (GET ...\/dispute\/).')

/**
 * POST /api/v1/invoices/{id}/dispute/send/
 */
export const InvoicesDisputeSendCreateParams = zod.object({
  "invoicePk": zod.string().uuid().describe('UUID of the parent invoice.')
})




export const InvoicesDisputeSendCreateBody = zod.object({
  "draftId": zod.string().min(1).nullish()
})

export const InvoicesDisputeSendCreateResponse = zod.object({
  "invoiceId": zod.string(),
  "status": zod.enum(['none', 'active', 'awaiting-vendor', 'resolved', 'withdrawn']).describe('\* `none` - None\n\* `active` - Active\n\* `awaiting-vendor` - Awaiting Vendor\n\* `resolved` - Resolved\n\* `withdrawn` - Withdrawn'),
  "initiatedAt": zod.string().datetime({"offset":true}).nullable(),
  "vendorPosition": zod.string().nullable(),
  "followUpCount": zod.number(),
  "maxFollowUps": zod.number(),
  "nextFollowUpDate": zod.string().datetime({"offset":true}).nullable(),
  "daysSinceLastContact": zod.number(),
  "resolution": zod.object({
  "resolutionType": zod.string(),
  "settledAmount": zod.string(),
  "savings": zod.string(),
  "notes": zod.string()
}).strict().nullable(),
  "suggestedActions": zod.array(zod.object({
  "action": zod.string(),
  "label": zod.string(),
  "reason": zod.string(),
  "priority": zod.enum(['primary', 'secondary', 'overflow']).describe('\* `primary` - primary\n\* `secondary` - secondary\n\* `overflow` - overflow'),
  "payload": zod.record(zod.string(), zod.unknown()).nullish()
}).strict().describe('An agent-suggested next action, embedded in the dispute state.')),
  "attentionReason": zod.string(),
  "currentDraft": zod.object({
  "draftType": zod.enum(['dispute', 'data_request', 'follow_up']).describe('\* `dispute` - Dispute\n\* `data_request` - Data Request\n\* `follow_up` - Follow Up'),
  "fromEmail": zod.string().optional().describe('Read-only; configured in the Email Integration Platform.'),
  "subject": zod.string(),
  "body": zod.string(),
  "to": zod.array(zod.string()),
  "cc": zod.array(zod.string()),
  "isAgentGenerated": zod.boolean(),
  "basedOnFindings": zod.boolean(),
  "attachments": zod.array(zod.object({
  "id": zod.string(),
  "filename": zod.string(),
  "fileType": zod.string().describe('e.g. \'pdf\' or \'image\'.'),
  "url": zod.string().nullable()
}).strict().describe('An attachment as embedded in a draft or timeline entry.')).optional(),
  "attachmentIds": zod.array(zod.string()).optional()
}).strict().nullable()
}).strict().describe('Full dispute agent state for an invoice (GET ...\/dispute\/).')

/**
 * GET /api/v1/invoices/{id}/dispute/timeline/
 */
export const InvoicesDisputeTimelineListParams = zod.object({
  "invoicePk": zod.string().uuid().describe('UUID of the parent invoice.')
})

export const InvoicesDisputeTimelineListResponseItem = zod.object({
  "id": zod.string(),
  "type": zod.enum(['dispute-email-sent', 'data-request-sent', 'follow-up-sent', 'vendor-response', 'non-vendor-reply', 'resolution', 'adjusted-invoice-linked', 'adjusted-invoice-approved', 'adjusted-invoice-rejected']).describe('\* `dispute-email-sent` - Dispute Email Sent\n\* `data-request-sent` - Data Request Sent\n\* `follow-up-sent` - Follow Up Sent\n\* `vendor-response` - Vendor Response\n\* `non-vendor-reply` - Other Reply\n\* `resolution` - Resolution\n\* `adjusted-invoice-linked` - Adjusted Invoice Linked\n\* `adjusted-invoice-approved` - Adjusted Invoice Approved\n\* `adjusted-invoice-rejected` - Adjusted Invoice Rejected'),
  "status": zod.enum(['pending', 'sent', 'failed']).describe('\* `pending` - Pending\n\* `sent` - Sent\n\* `failed` - Failed'),
  "timestamp": zod.string().datetime({"offset":true}),
  "direction": zod.union([zod.enum(['inbound', 'outbound']).describe('\* `inbound` - inbound\n\* `outbound` - outbound'),zod.literal(null)]).nullable(),
  "subject": zod.string(),
  "body": zod.string(),
  "sender": zod.string(),
  "recipients": zod.array(zod.string()),
  "cc": zod.array(zod.string()),
  "sentBy": zod.string().nullable(),
  "vendorPosition": zod.string().nullable(),
  "vendorResponseSummary": zod.string().nullable(),
  "senderRole": zod.union([zod.enum(['vendor_contact', 'consultant', 'unrecognized']).describe('\* `vendor_contact` - Vendor Contact\n\* `consultant` - Consultant\n\* `unrecognized` - Unrecognized'),zod.literal(null)]).nullable().describe('Classified role of an inbound sender; null for outbound entries. \'unrecognized\' flags a sender that matched no known vendor or consultant contact and should be verified.\n\n\* `vendor_contact` - Vendor Contact\n\* `consultant` - Consultant\n\* `unrecognized` - Unrecognized'),
  "isAutoReply": zod.boolean().describe('True when the inbound email was detected as an automated message (out-of-office, auto-responder, bounce).'),
  "emailPlatformId": zod.string().nullable(),
  "emailPlatformThreadId": zod.string().nullable(),
  "deliveryStatus": zod.union([zod.enum(['sent', 'delivered', 'deferred', 'bounced', 'dropped', 'spam-reported']).describe('\* `sent` - Sent\n\* `delivered` - Delivered\n\* `deferred` - Deferred\n\* `bounced` - Bounced\n\* `dropped` - Dropped\n\* `spam-reported` - Spam Reported'),zod.literal(null)]).nullable().describe('Delivery outcome for outbound emails, from the SendGrid Event Webhook. Null for inbound entries or before any event arrives.\n\n\* `sent` - Sent\n\* `delivered` - Delivered\n\* `deferred` - Deferred\n\* `bounced` - Bounced\n\* `dropped` - Dropped\n\* `spam-reported` - Spam Reported'),
  "deliveryStatusDetail": zod.string().describe('Reason from the delivery event (e.g. bounce reason).'),
  "attachments": zod.array(zod.object({
  "id": zod.string(),
  "filename": zod.string(),
  "fileType": zod.string().describe('e.g. \'pdf\' or \'image\'.'),
  "url": zod.string().nullable()
}).strict().describe('An attachment as embedded in a draft or timeline entry.')),
  "inboundAttachments": zod.array(zod.object({
  "filename": zod.string(),
  "contentType": zod.string(),
  "contentId": zod.string().nullable(),
  "attachmentId": zod.string().nullable(),
  "classification": zod.string().nullable()
}).strict().describe('Metadata for an inbound email attachment, embedded in a timeline entry.\n\n`attachment_id` is null when the file failed to store (e.g. unsupported\ntype); `classification` is null until the async classification task runs.')).describe('Metadata for inbound email attachments on this entry; empty for outbound entries or inbound entries with none.'),
  "failureReason": zod.string().describe('Why the send failed; populated only when status is \'failed\'.'),
  "failedAttachments": zod.array(zod.string()).describe('Evidence files that could not be loaded and did not go out.')
}).strict().describe('A single communication\/event in the dispute timeline.')
export const InvoicesDisputeTimelineListResponse = zod.array(InvoicesDisputeTimelineListResponseItem)

/**
 * POST /api/v1/invoices/{id}/dispute/withdraw/
 */
export const InvoicesDisputeWithdrawCreateParams = zod.object({
  "invoicePk": zod.string().uuid().describe('UUID of the parent invoice.')
})

export const invoicesDisputeWithdrawCreateBodyReasonDefault = ``;

export const InvoicesDisputeWithdrawCreateBody = zod.object({
  "reason": zod.string().default(invoicesDisputeWithdrawCreateBodyReasonDefault)
})

export const InvoicesDisputeWithdrawCreateResponse = zod.object({
  "invoiceId": zod.string(),
  "status": zod.enum(['none', 'active', 'awaiting-vendor', 'resolved', 'withdrawn']).describe('\* `none` - None\n\* `active` - Active\n\* `awaiting-vendor` - Awaiting Vendor\n\* `resolved` - Resolved\n\* `withdrawn` - Withdrawn'),
  "initiatedAt": zod.string().datetime({"offset":true}).nullable(),
  "vendorPosition": zod.string().nullable(),
  "followUpCount": zod.number(),
  "maxFollowUps": zod.number(),
  "nextFollowUpDate": zod.string().datetime({"offset":true}).nullable(),
  "daysSinceLastContact": zod.number(),
  "resolution": zod.object({
  "resolutionType": zod.string(),
  "settledAmount": zod.string(),
  "savings": zod.string(),
  "notes": zod.string()
}).strict().nullable(),
  "suggestedActions": zod.array(zod.object({
  "action": zod.string(),
  "label": zod.string(),
  "reason": zod.string(),
  "priority": zod.enum(['primary', 'secondary', 'overflow']).describe('\* `primary` - primary\n\* `secondary` - secondary\n\* `overflow` - overflow'),
  "payload": zod.record(zod.string(), zod.unknown()).nullish()
}).strict().describe('An agent-suggested next action, embedded in the dispute state.')),
  "attentionReason": zod.string(),
  "currentDraft": zod.object({
  "draftType": zod.enum(['dispute', 'data_request', 'follow_up']).describe('\* `dispute` - Dispute\n\* `data_request` - Data Request\n\* `follow_up` - Follow Up'),
  "fromEmail": zod.string().optional().describe('Read-only; configured in the Email Integration Platform.'),
  "subject": zod.string(),
  "body": zod.string(),
  "to": zod.array(zod.string()),
  "cc": zod.array(zod.string()),
  "isAgentGenerated": zod.boolean(),
  "basedOnFindings": zod.boolean(),
  "attachments": zod.array(zod.object({
  "id": zod.string(),
  "filename": zod.string(),
  "fileType": zod.string().describe('e.g. \'pdf\' or \'image\'.'),
  "url": zod.string().nullable()
}).strict().describe('An attachment as embedded in a draft or timeline entry.')).optional(),
  "attachmentIds": zod.array(zod.string()).optional()
}).strict().nullable()
}).strict().describe('Full dispute agent state for an invoice (GET ...\/dispute\/).')

export const InvoicesNotesListParams = zod.object({
  "invoicePk": zod.string().uuid()
})

export const InvoicesNotesListQueryParams = zod.object({
  "limit": zod.number().optional().describe('Number of results to return per page.'),
  "offset": zod.number().optional().describe('The initial index from which to return the results.')
})

export const invoicesNotesListResponseResultsItemAuthorOneUsernameMax = 150;


export const invoicesNotesListResponseResultsItemAuthorOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const invoicesNotesListResponseResultsItemAuthorOneEmailMax = 254;

export const invoicesNotesListResponseResultsItemAuthorOnePhoneNumberMax = 128;



export const InvoicesNotesListResponse = zod.object({
  "count": zod.number(),
  "next": zod.string().url().nullish(),
  "previous": zod.string().url().nullish(),
  "results": zod.array(zod.object({
  "id": zod.string().uuid(),
  "content": zod.string(),
  "author": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(invoicesNotesListResponseResultsItemAuthorOneUsernameMax).regex(invoicesNotesListResponseResultsItemAuthorOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(invoicesNotesListResponseResultsItemAuthorOneEmailMax).optional(),
  "phoneNumber": zod.string().max(invoicesNotesListResponseResultsItemAuthorOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])'))
}).strict()

export const InvoicesNotesCreateParams = zod.object({
  "invoicePk": zod.string().uuid()
})


export const invoicesNotesCreateBodyIsLiftAiDefault = false;

export const InvoicesNotesCreateBody = zod.object({
  "content": zod.string().min(1),
  "author": zod.string().uuid(),
  "invoice": zod.string().uuid(),
  "isLiftAi": zod.boolean().default(invoicesNotesCreateBodyIsLiftAiDefault)
})

export const invoicesNotesCreateResponseAuthorOneUsernameMax = 150;


export const invoicesNotesCreateResponseAuthorOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const invoicesNotesCreateResponseAuthorOneEmailMax = 254;

export const invoicesNotesCreateResponseAuthorOnePhoneNumberMax = 128;



export const InvoicesNotesCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "content": zod.string(),
  "author": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(invoicesNotesCreateResponseAuthorOneUsernameMax).regex(invoicesNotesCreateResponseAuthorOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(invoicesNotesCreateResponseAuthorOneEmailMax).optional(),
  "phoneNumber": zod.string().max(invoicesNotesCreateResponseAuthorOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const InvoicesNotesRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this note.'),
  "invoicePk": zod.string().uuid()
})

export const invoicesNotesRetrieveResponseAuthorOneUsernameMax = 150;


export const invoicesNotesRetrieveResponseAuthorOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const invoicesNotesRetrieveResponseAuthorOneEmailMax = 254;

export const invoicesNotesRetrieveResponseAuthorOnePhoneNumberMax = 128;



export const InvoicesNotesRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "content": zod.string(),
  "author": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(invoicesNotesRetrieveResponseAuthorOneUsernameMax).regex(invoicesNotesRetrieveResponseAuthorOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(invoicesNotesRetrieveResponseAuthorOneEmailMax).optional(),
  "phoneNumber": zod.string().max(invoicesNotesRetrieveResponseAuthorOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const InvoicesNotesUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this note.'),
  "invoicePk": zod.string().uuid()
})




export const InvoicesNotesUpdateBody = zod.object({
  "content": zod.string().min(1)
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const invoicesNotesUpdateResponseAuthorOneUsernameMax = 150;


export const invoicesNotesUpdateResponseAuthorOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const invoicesNotesUpdateResponseAuthorOneEmailMax = 254;

export const invoicesNotesUpdateResponseAuthorOnePhoneNumberMax = 128;



export const InvoicesNotesUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "content": zod.string(),
  "author": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(invoicesNotesUpdateResponseAuthorOneUsernameMax).regex(invoicesNotesUpdateResponseAuthorOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(invoicesNotesUpdateResponseAuthorOneEmailMax).optional(),
  "phoneNumber": zod.string().max(invoicesNotesUpdateResponseAuthorOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const InvoicesNotesPartialUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this note.'),
  "invoicePk": zod.string().uuid()
})




export const InvoicesNotesPartialUpdateBody = zod.object({
  "content": zod.string().min(1).optional()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const invoicesNotesPartialUpdateResponseAuthorOneUsernameMax = 150;


export const invoicesNotesPartialUpdateResponseAuthorOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const invoicesNotesPartialUpdateResponseAuthorOneEmailMax = 254;

export const invoicesNotesPartialUpdateResponseAuthorOnePhoneNumberMax = 128;



export const InvoicesNotesPartialUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "content": zod.string(),
  "author": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(invoicesNotesPartialUpdateResponseAuthorOneUsernameMax).regex(invoicesNotesPartialUpdateResponseAuthorOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(invoicesNotesPartialUpdateResponseAuthorOneEmailMax).optional(),
  "phoneNumber": zod.string().max(invoicesNotesPartialUpdateResponseAuthorOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const InvoicesNotesDestroyParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this note.'),
  "invoicePk": zod.string().uuid()
})

export const InvoicesNotesDestroyResponse = zod.void()

/**
 * Basic API CRUD access to Invoice entities.
 */
export const InvoicesRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this invoice.')
})

export const invoicesRetrieveResponseNumberMax = 100;

export const invoicesRetrieveResponseConsultantOneUsernameMax = 150;


export const invoicesRetrieveResponseConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const invoicesRetrieveResponseConsultantOneEmailMax = 254;

export const invoicesRetrieveResponseConsultantOnePhoneNumberMax = 128;

export const invoicesRetrieveResponseProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesRetrieveResponseReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesRetrieveResponseApprovedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesRetrieveResponseLineItemsItemAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesRetrieveResponseAttachmentsItemPageNumberMin = 0;
export const invoicesRetrieveResponseAttachmentsItemPageNumberMax = 2147483647;

export const invoicesRetrieveResponseSavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesRetrieveResponseTicketsItemNumberMax = 20;

export const invoicesRetrieveResponseRelatedInvoicesItemNumberMax = 100;

export const invoicesRetrieveResponseRelatedInvoicesItemProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesRetrieveResponseRelatedInvoicesItemReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesRetrieveResponseRelatedInvoicesItemAttachmentsItemPageNumberMin = 0;
export const invoicesRetrieveResponseRelatedInvoicesItemAttachmentsItemPageNumberMax = 2147483647;

export const invoicesRetrieveResponseParentInvoiceOneNumberMax = 100;

export const invoicesRetrieveResponseParentInvoiceOneProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesRetrieveResponseAdjustmentsItemNumberMax = 100;

export const invoicesRetrieveResponseAdjustmentsItemProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesRetrieveResponseCreditedInvoiceOneNumberMax = 100;

export const invoicesRetrieveResponseCreditedInvoiceOneProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesRetrieveResponseCreditedInvoiceOneReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesRetrieveResponseCreditedInvoiceOneSavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesRetrieveResponseCreditedInvoiceOneDisputeSavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesRetrieveResponseCreditsItemNumberMax = 100;

export const invoicesRetrieveResponseCreditsItemProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesRetrieveResponseUploadedByOneUsernameMax = 150;


export const invoicesRetrieveResponseUploadedByOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const invoicesRetrieveResponseUploadedByOneEmailMax = 254;

export const invoicesRetrieveResponseUploadedByOnePhoneNumberMax = 128;



export const InvoicesRetrieveResponse = zod.object({
  "number": zod.string().max(invoicesRetrieveResponseNumberMax),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "disputeStatus": zod.enum(['none', 'active', 'awaiting-vendor', 'resolved', 'withdrawn']).optional().describe('\* `none` - None\n\* `active` - Active\n\* `awaiting-vendor` - Awaiting Vendor\n\* `resolved` - Resolved\n\* `withdrawn` - Withdrawn'),
  "disputeNeedsAttention": zod.boolean().describe('Returns True when the dispute is active and a vendor response\nhas been analyzed, indicating the consultant needs to take action.'),
  "type": zod.enum(['maintenance', 'modernization', 'callback', 'inspection', 'repair', 'fee']).describe('\* `maintenance` - Maintenance\n\* `modernization` - Modernization\n\* `callback` - Callback\n\* `inspection` - Inspection\n\* `repair` - Repair\n\* `fee` - Late Fee \/ Service Fee'),
  "kind": zod.enum(['invoice', 'proposal', 'credit']).describe('\* `invoice` - Invoice\n\* `proposal` - Proposal\n\* `credit` - Credit'),
  "reason": zod.string().optional(),
  "rejectionCategory": zod.array(zod.enum(['billing-rate-incorrect', 'no-time-tickets', 'required-hours-incorrect', 'miscellaneous-fees', 'covered-by-contract', 'work-not-required', 'material-markup-incorrect', 'material-quantity-incorrect', 'pre-negotiated-price-not-followed', 'other']).describe('\* `billing-rate-incorrect` - Billing Rate Incorrect\n\* `no-time-tickets` - No Time Tickets\n\* `required-hours-incorrect` - Required Hours Incorrect\n\* `miscellaneous-fees` - Miscellaneous Fees\n\* `covered-by-contract` - Covered By Contract\n\* `work-not-required` - Work Not Required\n\* `material-markup-incorrect` - Material Markup Incorrect\n\* `material-quantity-incorrect` - Material Quantity Incorrect\n\* `pre-negotiated-price-not-followed` - Pre-negotiated Price Not Followed\n\* `other` - Other')).nullish(),
  "description": zod.string().optional(),
  "region": zod.string().nullable(),
  "consultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(invoicesRetrieveResponseConsultantOneUsernameMax).regex(invoicesRetrieveResponseConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(invoicesRetrieveResponseConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(invoicesRetrieveResponseConsultantOnePhoneNumberMax).optional()
}).strict().nullable(),
  "proposedAmount": zod.string().regex(invoicesRetrieveResponseProposedAmountRegExp).nullish(),
  "reviewedAmount": zod.string().regex(invoicesRetrieveResponseReviewedAmountRegExp).nullish(),
  "approvedAmount": zod.string().regex(invoicesRetrieveResponseApprovedAmountRegExp),
  "serviceProvider": zod.object({
  "name": zod.string().optional(),
  "id": zod.string().uuid().optional()
}).strict().nullable(),
  "date": zod.string().date().nullish(),
  "dateStamped": zod.string().datetime({"offset":true}).nullish(),
  "id": zod.string().uuid(),
  "carsServiced": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "ahjId": zod.string().optional(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish()
}).strict()),
  "lineItems": zod.array(zod.object({
  "id": zod.number(),
  "description": zod.string(),
  "amount": zod.string().regex(invoicesRetrieveResponseLineItemsItemAmountRegExp)
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "property": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "address": zod.string().nullable(),
  "timeZone": zod.string().optional()
}).strict().nullable(),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesRetrieveResponseAttachmentsItemPageNumberMin).max(invoicesRetrieveResponseAttachmentsItemPageNumberMax).nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "addStampedReason": zod.boolean().optional(),
  "consultantGroup": zod.string().uuid().nullable(),
  "autoUpload": zod.boolean().optional(),
  "savings": zod.string().regex(invoicesRetrieveResponseSavingsRegExp).nullish(),
  "tickets": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesRetrieveResponseTicketsItemNumberMax),
  "property": zod.string().uuid().nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "relatedInvoices": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesRetrieveResponseRelatedInvoicesItemNumberMax),
  "proposedAmount": zod.string().regex(invoicesRetrieveResponseRelatedInvoicesItemProposedAmountRegExp).nullish(),
  "reviewedAmount": zod.string().regex(invoicesRetrieveResponseRelatedInvoicesItemReviewedAmountRegExp).nullish(),
  "kind": zod.enum(['invoice', 'proposal', 'credit']).describe('\* `invoice` - Invoice\n\* `proposal` - Proposal\n\* `credit` - Credit'),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesRetrieveResponseRelatedInvoicesItemAttachmentsItemPageNumberMin).max(invoicesRetrieveResponseRelatedInvoicesItemAttachmentsItemPageNumberMax).nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])'))
}).strict()),
  "parentInvoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesRetrieveResponseParentInvoiceOneNumberMax),
  "proposedAmount": zod.string().regex(invoicesRetrieveResponseParentInvoiceOneProposedAmountRegExp).nullish()
}).strict().nullable(),
  "adjustmentSource": zod.union([zod.enum(['manual', 'agent']).describe('\* `manual` - Manual\n\* `agent` - Agent'),zod.enum(['']),zod.literal(null)]).nullish().describe('How the adjustment link was created: manually by consultant or automatically by agent.\n\n\* `manual` - Manual\n\* `agent` - Agent'),
  "adjustments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesRetrieveResponseAdjustmentsItemNumberMax),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "proposedAmount": zod.string().regex(invoicesRetrieveResponseAdjustmentsItemProposedAmountRegExp).nullish(),
  "adjustmentSource": zod.union([zod.enum(['manual', 'agent']).describe('\* `manual` - Manual\n\* `agent` - Agent'),zod.enum(['']),zod.literal(null)]).nullish().describe('How the adjustment link was created: manually by consultant or automatically by agent.\n\n\* `manual` - Manual\n\* `agent` - Agent'),
  "savingsDelta": zod.number().nullable()
}).strict()),
  "keepOnFileOnly": zod.boolean().optional(),
  "creditedInvoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesRetrieveResponseCreditedInvoiceOneNumberMax),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "proposedAmount": zod.string().regex(invoicesRetrieveResponseCreditedInvoiceOneProposedAmountRegExp).nullish(),
  "reviewedAmount": zod.string().regex(invoicesRetrieveResponseCreditedInvoiceOneReviewedAmountRegExp).nullish(),
  "savings": zod.string().regex(invoicesRetrieveResponseCreditedInvoiceOneSavingsRegExp).nullish(),
  "disputeSavings": zod.string().regex(invoicesRetrieveResponseCreditedInvoiceOneDisputeSavingsRegExp).nullish()
}).strict().nullable(),
  "credits": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesRetrieveResponseCreditsItemNumberMax),
  "date": zod.string().date().nullish(),
  "proposedAmount": zod.string().regex(invoicesRetrieveResponseCreditsItemProposedAmountRegExp).nullish(),
  "keepOnFileOnly": zod.boolean().optional()
}).strict()),
  "countsTowardSpend": zod.boolean().nullable(),
  "stampFile": zod.string().url().nullable(),
  "insights": zod.unknown().nullable(),
  "insightStatus": zod.enum(['pending', 'processing', 'completed', 'failed']).describe('\* `pending` - Pending\n\* `processing` - Processing\n\* `completed` - Completed\n\* `failed` - Failed').optional().describe('Current status of insight generation\n\n\* `pending` - Pending\n\* `processing` - Processing\n\* `completed` - Completed\n\* `failed` - Failed'),
  "activeContractId": zod.string().uuid().nullable().describe('Id of the contract whose terms govern this invoice (by property + date\noverlap), or None when it can\'t be resolved. Powers the AI-vs-consultant\nrule-suggestion flow, which needs the contract to draft a review rule.\n\nResolved only for single-object (detail) responses — the rule-suggestion\nchat tool loops back to the invoice detail endpoint. Skipped during list\nserialization because find_active_property_contract issues per-invoice\nqueries the list queryset can\'t prefetch, which would N+1.'),
  "source": zod.string().nullable(),
  "emailContext": zod.object({
  "sender": zod.string(),
  "subject": zod.string(),
  "textBody": zod.string(),
  "receivedAt": zod.string().datetime({"offset":true})
}).strict().nullable(),
  "uploadedBy": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(invoicesRetrieveResponseUploadedByOneUsernameMax).regex(invoicesRetrieveResponseUploadedByOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(invoicesRetrieveResponseUploadedByOneEmailMax).optional(),
  "phoneNumber": zod.string().max(invoicesRetrieveResponseUploadedByOnePhoneNumberMax).optional()
}).strict().nullable(),
  "uploadedAt": zod.string().datetime({"offset":true}).nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "projectedSavings": zod.number().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Basic API CRUD access to Invoice entities.
 */
export const InvoicesUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this invoice.')
})

export const invoicesUpdateBodyNumberMax = 100;


export const invoicesUpdateBodyLineItemsItemAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesUpdateBodyProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesUpdateBodyReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesUpdateBodySavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');


export const InvoicesUpdateBody = zod.object({
  "number": zod.string().min(1).max(invoicesUpdateBodyNumberMax),
  "date": zod.string().date().optional(),
  "kind": zod.enum(['invoice', 'proposal', 'credit']).describe('\* `invoice` - Invoice\n\* `proposal` - Proposal\n\* `credit` - Credit'),
  "type": zod.enum(['maintenance', 'modernization', 'callback', 'inspection', 'repair', 'fee']).optional().describe('\* `maintenance` - Maintenance\n\* `modernization` - Modernization\n\* `callback` - Callback\n\* `inspection` - Inspection\n\* `repair` - Repair\n\* `fee` - Late Fee \/ Service Fee'),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "lineItems": zod.array(zod.object({
  "id": zod.number().optional(),
  "description": zod.string().min(1),
  "amount": zod.string().regex(invoicesUpdateBodyLineItemsItemAmountRegExp)
})).optional(),
  "proposedAmount": zod.string().regex(invoicesUpdateBodyProposedAmountRegExp).optional(),
  "reviewedAmount": zod.string().regex(invoicesUpdateBodyReviewedAmountRegExp).nullish(),
  "savings": zod.string().regex(invoicesUpdateBodySavingsRegExp).nullish(),
  "description": zod.string().optional(),
  "reason": zod.string().optional(),
  "dateStamped": zod.string().datetime({"offset":true}).nullish(),
  "propertyId": zod.string().uuid(),
  "consultantId": zod.string().uuid(),
  "serviceProviderId": zod.string().uuid().optional(),
  "carIds": zod.array(zod.string().uuid()).optional(),
  "addStampedReason": zod.boolean().optional(),
  "relatedInvoices": zod.array(zod.string().uuid()).optional(),
  "rejectionCategory": zod.array(zod.enum(['billing-rate-incorrect', 'no-time-tickets', 'required-hours-incorrect', 'miscellaneous-fees', 'covered-by-contract', 'work-not-required', 'material-markup-incorrect', 'material-quantity-incorrect', 'pre-negotiated-price-not-followed', 'other']).describe('\* `billing-rate-incorrect` - Billing Rate Incorrect\n\* `no-time-tickets` - No Time Tickets\n\* `required-hours-incorrect` - Required Hours Incorrect\n\* `miscellaneous-fees` - Miscellaneous Fees\n\* `covered-by-contract` - Covered By Contract\n\* `work-not-required` - Work Not Required\n\* `material-markup-incorrect` - Material Markup Incorrect\n\* `material-quantity-incorrect` - Material Quantity Incorrect\n\* `pre-negotiated-price-not-followed` - Pre-negotiated Price Not Followed\n\* `other` - Other')).nullish(),
  "parentInvoiceId": zod.string().uuid().nullish(),
  "creditedInvoiceId": zod.string().uuid().nullish(),
  "keepOnFileOnly": zod.boolean().optional()
})

export const invoicesUpdateResponseNumberMax = 100;

export const invoicesUpdateResponseConsultantOneUsernameMax = 150;


export const invoicesUpdateResponseConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const invoicesUpdateResponseConsultantOneEmailMax = 254;

export const invoicesUpdateResponseConsultantOnePhoneNumberMax = 128;

export const invoicesUpdateResponseProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesUpdateResponseReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesUpdateResponseApprovedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesUpdateResponseLineItemsItemAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesUpdateResponseAttachmentsItemPageNumberMin = 0;
export const invoicesUpdateResponseAttachmentsItemPageNumberMax = 2147483647;

export const invoicesUpdateResponseSavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesUpdateResponseTicketsItemNumberMax = 20;

export const invoicesUpdateResponseRelatedInvoicesItemNumberMax = 100;

export const invoicesUpdateResponseRelatedInvoicesItemProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesUpdateResponseRelatedInvoicesItemReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesUpdateResponseRelatedInvoicesItemAttachmentsItemPageNumberMin = 0;
export const invoicesUpdateResponseRelatedInvoicesItemAttachmentsItemPageNumberMax = 2147483647;

export const invoicesUpdateResponseParentInvoiceOneNumberMax = 100;

export const invoicesUpdateResponseParentInvoiceOneProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesUpdateResponseAdjustmentsItemNumberMax = 100;

export const invoicesUpdateResponseAdjustmentsItemProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesUpdateResponseCreditedInvoiceOneNumberMax = 100;

export const invoicesUpdateResponseCreditedInvoiceOneProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesUpdateResponseCreditedInvoiceOneReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesUpdateResponseCreditedInvoiceOneSavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesUpdateResponseCreditedInvoiceOneDisputeSavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesUpdateResponseCreditsItemNumberMax = 100;

export const invoicesUpdateResponseCreditsItemProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesUpdateResponseUploadedByOneUsernameMax = 150;


export const invoicesUpdateResponseUploadedByOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const invoicesUpdateResponseUploadedByOneEmailMax = 254;

export const invoicesUpdateResponseUploadedByOnePhoneNumberMax = 128;



export const InvoicesUpdateResponse = zod.object({
  "number": zod.string().max(invoicesUpdateResponseNumberMax),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "disputeStatus": zod.enum(['none', 'active', 'awaiting-vendor', 'resolved', 'withdrawn']).optional().describe('\* `none` - None\n\* `active` - Active\n\* `awaiting-vendor` - Awaiting Vendor\n\* `resolved` - Resolved\n\* `withdrawn` - Withdrawn'),
  "disputeNeedsAttention": zod.boolean().describe('Returns True when the dispute is active and a vendor response\nhas been analyzed, indicating the consultant needs to take action.'),
  "type": zod.enum(['maintenance', 'modernization', 'callback', 'inspection', 'repair', 'fee']).describe('\* `maintenance` - Maintenance\n\* `modernization` - Modernization\n\* `callback` - Callback\n\* `inspection` - Inspection\n\* `repair` - Repair\n\* `fee` - Late Fee \/ Service Fee'),
  "kind": zod.enum(['invoice', 'proposal', 'credit']).describe('\* `invoice` - Invoice\n\* `proposal` - Proposal\n\* `credit` - Credit'),
  "reason": zod.string().optional(),
  "rejectionCategory": zod.array(zod.enum(['billing-rate-incorrect', 'no-time-tickets', 'required-hours-incorrect', 'miscellaneous-fees', 'covered-by-contract', 'work-not-required', 'material-markup-incorrect', 'material-quantity-incorrect', 'pre-negotiated-price-not-followed', 'other']).describe('\* `billing-rate-incorrect` - Billing Rate Incorrect\n\* `no-time-tickets` - No Time Tickets\n\* `required-hours-incorrect` - Required Hours Incorrect\n\* `miscellaneous-fees` - Miscellaneous Fees\n\* `covered-by-contract` - Covered By Contract\n\* `work-not-required` - Work Not Required\n\* `material-markup-incorrect` - Material Markup Incorrect\n\* `material-quantity-incorrect` - Material Quantity Incorrect\n\* `pre-negotiated-price-not-followed` - Pre-negotiated Price Not Followed\n\* `other` - Other')).nullish(),
  "description": zod.string().optional(),
  "region": zod.string().nullable(),
  "consultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(invoicesUpdateResponseConsultantOneUsernameMax).regex(invoicesUpdateResponseConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(invoicesUpdateResponseConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(invoicesUpdateResponseConsultantOnePhoneNumberMax).optional()
}).strict().nullable(),
  "proposedAmount": zod.string().regex(invoicesUpdateResponseProposedAmountRegExp).nullish(),
  "reviewedAmount": zod.string().regex(invoicesUpdateResponseReviewedAmountRegExp).nullish(),
  "approvedAmount": zod.string().regex(invoicesUpdateResponseApprovedAmountRegExp),
  "serviceProvider": zod.object({
  "name": zod.string().optional(),
  "id": zod.string().uuid().optional()
}).strict().nullable(),
  "date": zod.string().date().nullish(),
  "dateStamped": zod.string().datetime({"offset":true}).nullish(),
  "id": zod.string().uuid(),
  "carsServiced": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "ahjId": zod.string().optional(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish()
}).strict()),
  "lineItems": zod.array(zod.object({
  "id": zod.number(),
  "description": zod.string(),
  "amount": zod.string().regex(invoicesUpdateResponseLineItemsItemAmountRegExp)
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "property": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "address": zod.string().nullable(),
  "timeZone": zod.string().optional()
}).strict().nullable(),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesUpdateResponseAttachmentsItemPageNumberMin).max(invoicesUpdateResponseAttachmentsItemPageNumberMax).nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "addStampedReason": zod.boolean().optional(),
  "consultantGroup": zod.string().uuid().nullable(),
  "autoUpload": zod.boolean().optional(),
  "savings": zod.string().regex(invoicesUpdateResponseSavingsRegExp).nullish(),
  "tickets": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesUpdateResponseTicketsItemNumberMax),
  "property": zod.string().uuid().nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "relatedInvoices": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesUpdateResponseRelatedInvoicesItemNumberMax),
  "proposedAmount": zod.string().regex(invoicesUpdateResponseRelatedInvoicesItemProposedAmountRegExp).nullish(),
  "reviewedAmount": zod.string().regex(invoicesUpdateResponseRelatedInvoicesItemReviewedAmountRegExp).nullish(),
  "kind": zod.enum(['invoice', 'proposal', 'credit']).describe('\* `invoice` - Invoice\n\* `proposal` - Proposal\n\* `credit` - Credit'),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesUpdateResponseRelatedInvoicesItemAttachmentsItemPageNumberMin).max(invoicesUpdateResponseRelatedInvoicesItemAttachmentsItemPageNumberMax).nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])'))
}).strict()),
  "parentInvoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesUpdateResponseParentInvoiceOneNumberMax),
  "proposedAmount": zod.string().regex(invoicesUpdateResponseParentInvoiceOneProposedAmountRegExp).nullish()
}).strict().nullable(),
  "adjustmentSource": zod.union([zod.enum(['manual', 'agent']).describe('\* `manual` - Manual\n\* `agent` - Agent'),zod.enum(['']),zod.literal(null)]).nullish().describe('How the adjustment link was created: manually by consultant or automatically by agent.\n\n\* `manual` - Manual\n\* `agent` - Agent'),
  "adjustments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesUpdateResponseAdjustmentsItemNumberMax),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "proposedAmount": zod.string().regex(invoicesUpdateResponseAdjustmentsItemProposedAmountRegExp).nullish(),
  "adjustmentSource": zod.union([zod.enum(['manual', 'agent']).describe('\* `manual` - Manual\n\* `agent` - Agent'),zod.enum(['']),zod.literal(null)]).nullish().describe('How the adjustment link was created: manually by consultant or automatically by agent.\n\n\* `manual` - Manual\n\* `agent` - Agent'),
  "savingsDelta": zod.number().nullable()
}).strict()),
  "keepOnFileOnly": zod.boolean().optional(),
  "creditedInvoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesUpdateResponseCreditedInvoiceOneNumberMax),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "proposedAmount": zod.string().regex(invoicesUpdateResponseCreditedInvoiceOneProposedAmountRegExp).nullish(),
  "reviewedAmount": zod.string().regex(invoicesUpdateResponseCreditedInvoiceOneReviewedAmountRegExp).nullish(),
  "savings": zod.string().regex(invoicesUpdateResponseCreditedInvoiceOneSavingsRegExp).nullish(),
  "disputeSavings": zod.string().regex(invoicesUpdateResponseCreditedInvoiceOneDisputeSavingsRegExp).nullish()
}).strict().nullable(),
  "credits": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesUpdateResponseCreditsItemNumberMax),
  "date": zod.string().date().nullish(),
  "proposedAmount": zod.string().regex(invoicesUpdateResponseCreditsItemProposedAmountRegExp).nullish(),
  "keepOnFileOnly": zod.boolean().optional()
}).strict()),
  "countsTowardSpend": zod.boolean().nullable(),
  "stampFile": zod.string().url().nullable(),
  "insights": zod.unknown().nullable(),
  "insightStatus": zod.enum(['pending', 'processing', 'completed', 'failed']).describe('\* `pending` - Pending\n\* `processing` - Processing\n\* `completed` - Completed\n\* `failed` - Failed').optional().describe('Current status of insight generation\n\n\* `pending` - Pending\n\* `processing` - Processing\n\* `completed` - Completed\n\* `failed` - Failed'),
  "activeContractId": zod.string().uuid().nullable().describe('Id of the contract whose terms govern this invoice (by property + date\noverlap), or None when it can\'t be resolved. Powers the AI-vs-consultant\nrule-suggestion flow, which needs the contract to draft a review rule.\n\nResolved only for single-object (detail) responses — the rule-suggestion\nchat tool loops back to the invoice detail endpoint. Skipped during list\nserialization because find_active_property_contract issues per-invoice\nqueries the list queryset can\'t prefetch, which would N+1.'),
  "source": zod.string().nullable(),
  "emailContext": zod.object({
  "sender": zod.string(),
  "subject": zod.string(),
  "textBody": zod.string(),
  "receivedAt": zod.string().datetime({"offset":true})
}).strict().nullable(),
  "uploadedBy": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(invoicesUpdateResponseUploadedByOneUsernameMax).regex(invoicesUpdateResponseUploadedByOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(invoicesUpdateResponseUploadedByOneEmailMax).optional(),
  "phoneNumber": zod.string().max(invoicesUpdateResponseUploadedByOnePhoneNumberMax).optional()
}).strict().nullable(),
  "uploadedAt": zod.string().datetime({"offset":true}).nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "projectedSavings": zod.number().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Basic API CRUD access to Invoice entities.
 */
export const InvoicesPartialUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this invoice.')
})

export const invoicesPartialUpdateBodyNumberMax = 100;


export const invoicesPartialUpdateBodyLineItemsItemAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesPartialUpdateBodyProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesPartialUpdateBodyReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesPartialUpdateBodySavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');


export const InvoicesPartialUpdateBody = zod.object({
  "number": zod.string().min(1).max(invoicesPartialUpdateBodyNumberMax).optional(),
  "date": zod.string().date().optional(),
  "kind": zod.enum(['invoice', 'proposal', 'credit']).optional().describe('\* `invoice` - Invoice\n\* `proposal` - Proposal\n\* `credit` - Credit'),
  "type": zod.enum(['maintenance', 'modernization', 'callback', 'inspection', 'repair', 'fee']).optional().describe('\* `maintenance` - Maintenance\n\* `modernization` - Modernization\n\* `callback` - Callback\n\* `inspection` - Inspection\n\* `repair` - Repair\n\* `fee` - Late Fee \/ Service Fee'),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).optional().describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "lineItems": zod.array(zod.object({
  "id": zod.number().optional(),
  "description": zod.string().min(1),
  "amount": zod.string().regex(invoicesPartialUpdateBodyLineItemsItemAmountRegExp)
})).optional(),
  "proposedAmount": zod.string().regex(invoicesPartialUpdateBodyProposedAmountRegExp).optional(),
  "reviewedAmount": zod.string().regex(invoicesPartialUpdateBodyReviewedAmountRegExp).nullish(),
  "savings": zod.string().regex(invoicesPartialUpdateBodySavingsRegExp).nullish(),
  "description": zod.string().optional(),
  "reason": zod.string().optional(),
  "dateStamped": zod.string().datetime({"offset":true}).nullish(),
  "propertyId": zod.string().uuid().optional(),
  "consultantId": zod.string().uuid().optional(),
  "serviceProviderId": zod.string().uuid().optional(),
  "carIds": zod.array(zod.string().uuid()).optional(),
  "addStampedReason": zod.boolean().optional(),
  "relatedInvoices": zod.array(zod.string().uuid()).optional(),
  "rejectionCategory": zod.array(zod.enum(['billing-rate-incorrect', 'no-time-tickets', 'required-hours-incorrect', 'miscellaneous-fees', 'covered-by-contract', 'work-not-required', 'material-markup-incorrect', 'material-quantity-incorrect', 'pre-negotiated-price-not-followed', 'other']).describe('\* `billing-rate-incorrect` - Billing Rate Incorrect\n\* `no-time-tickets` - No Time Tickets\n\* `required-hours-incorrect` - Required Hours Incorrect\n\* `miscellaneous-fees` - Miscellaneous Fees\n\* `covered-by-contract` - Covered By Contract\n\* `work-not-required` - Work Not Required\n\* `material-markup-incorrect` - Material Markup Incorrect\n\* `material-quantity-incorrect` - Material Quantity Incorrect\n\* `pre-negotiated-price-not-followed` - Pre-negotiated Price Not Followed\n\* `other` - Other')).nullish(),
  "parentInvoiceId": zod.string().uuid().nullish(),
  "creditedInvoiceId": zod.string().uuid().nullish(),
  "keepOnFileOnly": zod.boolean().optional()
})

export const invoicesPartialUpdateResponseNumberMax = 100;

export const invoicesPartialUpdateResponseConsultantOneUsernameMax = 150;


export const invoicesPartialUpdateResponseConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const invoicesPartialUpdateResponseConsultantOneEmailMax = 254;

export const invoicesPartialUpdateResponseConsultantOnePhoneNumberMax = 128;

export const invoicesPartialUpdateResponseProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesPartialUpdateResponseReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesPartialUpdateResponseApprovedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesPartialUpdateResponseLineItemsItemAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesPartialUpdateResponseAttachmentsItemPageNumberMin = 0;
export const invoicesPartialUpdateResponseAttachmentsItemPageNumberMax = 2147483647;

export const invoicesPartialUpdateResponseSavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesPartialUpdateResponseTicketsItemNumberMax = 20;

export const invoicesPartialUpdateResponseRelatedInvoicesItemNumberMax = 100;

export const invoicesPartialUpdateResponseRelatedInvoicesItemProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesPartialUpdateResponseRelatedInvoicesItemReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesPartialUpdateResponseRelatedInvoicesItemAttachmentsItemPageNumberMin = 0;
export const invoicesPartialUpdateResponseRelatedInvoicesItemAttachmentsItemPageNumberMax = 2147483647;

export const invoicesPartialUpdateResponseParentInvoiceOneNumberMax = 100;

export const invoicesPartialUpdateResponseParentInvoiceOneProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesPartialUpdateResponseAdjustmentsItemNumberMax = 100;

export const invoicesPartialUpdateResponseAdjustmentsItemProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesPartialUpdateResponseCreditedInvoiceOneNumberMax = 100;

export const invoicesPartialUpdateResponseCreditedInvoiceOneProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesPartialUpdateResponseCreditedInvoiceOneReviewedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesPartialUpdateResponseCreditedInvoiceOneSavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesPartialUpdateResponseCreditedInvoiceOneDisputeSavingsRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesPartialUpdateResponseCreditsItemNumberMax = 100;

export const invoicesPartialUpdateResponseCreditsItemProposedAmountRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const invoicesPartialUpdateResponseUploadedByOneUsernameMax = 150;


export const invoicesPartialUpdateResponseUploadedByOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const invoicesPartialUpdateResponseUploadedByOneEmailMax = 254;

export const invoicesPartialUpdateResponseUploadedByOnePhoneNumberMax = 128;



export const InvoicesPartialUpdateResponse = zod.object({
  "number": zod.string().max(invoicesPartialUpdateResponseNumberMax),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "disputeStatus": zod.enum(['none', 'active', 'awaiting-vendor', 'resolved', 'withdrawn']).optional().describe('\* `none` - None\n\* `active` - Active\n\* `awaiting-vendor` - Awaiting Vendor\n\* `resolved` - Resolved\n\* `withdrawn` - Withdrawn'),
  "disputeNeedsAttention": zod.boolean().describe('Returns True when the dispute is active and a vendor response\nhas been analyzed, indicating the consultant needs to take action.'),
  "type": zod.enum(['maintenance', 'modernization', 'callback', 'inspection', 'repair', 'fee']).describe('\* `maintenance` - Maintenance\n\* `modernization` - Modernization\n\* `callback` - Callback\n\* `inspection` - Inspection\n\* `repair` - Repair\n\* `fee` - Late Fee \/ Service Fee'),
  "kind": zod.enum(['invoice', 'proposal', 'credit']).describe('\* `invoice` - Invoice\n\* `proposal` - Proposal\n\* `credit` - Credit'),
  "reason": zod.string().optional(),
  "rejectionCategory": zod.array(zod.enum(['billing-rate-incorrect', 'no-time-tickets', 'required-hours-incorrect', 'miscellaneous-fees', 'covered-by-contract', 'work-not-required', 'material-markup-incorrect', 'material-quantity-incorrect', 'pre-negotiated-price-not-followed', 'other']).describe('\* `billing-rate-incorrect` - Billing Rate Incorrect\n\* `no-time-tickets` - No Time Tickets\n\* `required-hours-incorrect` - Required Hours Incorrect\n\* `miscellaneous-fees` - Miscellaneous Fees\n\* `covered-by-contract` - Covered By Contract\n\* `work-not-required` - Work Not Required\n\* `material-markup-incorrect` - Material Markup Incorrect\n\* `material-quantity-incorrect` - Material Quantity Incorrect\n\* `pre-negotiated-price-not-followed` - Pre-negotiated Price Not Followed\n\* `other` - Other')).nullish(),
  "description": zod.string().optional(),
  "region": zod.string().nullable(),
  "consultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(invoicesPartialUpdateResponseConsultantOneUsernameMax).regex(invoicesPartialUpdateResponseConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(invoicesPartialUpdateResponseConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(invoicesPartialUpdateResponseConsultantOnePhoneNumberMax).optional()
}).strict().nullable(),
  "proposedAmount": zod.string().regex(invoicesPartialUpdateResponseProposedAmountRegExp).nullish(),
  "reviewedAmount": zod.string().regex(invoicesPartialUpdateResponseReviewedAmountRegExp).nullish(),
  "approvedAmount": zod.string().regex(invoicesPartialUpdateResponseApprovedAmountRegExp),
  "serviceProvider": zod.object({
  "name": zod.string().optional(),
  "id": zod.string().uuid().optional()
}).strict().nullable(),
  "date": zod.string().date().nullish(),
  "dateStamped": zod.string().datetime({"offset":true}).nullish(),
  "id": zod.string().uuid(),
  "carsServiced": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "ahjId": zod.string().optional(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish()
}).strict()),
  "lineItems": zod.array(zod.object({
  "id": zod.number(),
  "description": zod.string(),
  "amount": zod.string().regex(invoicesPartialUpdateResponseLineItemsItemAmountRegExp)
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "property": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "address": zod.string().nullable(),
  "timeZone": zod.string().optional()
}).strict().nullable(),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesPartialUpdateResponseAttachmentsItemPageNumberMin).max(invoicesPartialUpdateResponseAttachmentsItemPageNumberMax).nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "addStampedReason": zod.boolean().optional(),
  "consultantGroup": zod.string().uuid().nullable(),
  "autoUpload": zod.boolean().optional(),
  "savings": zod.string().regex(invoicesPartialUpdateResponseSavingsRegExp).nullish(),
  "tickets": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesPartialUpdateResponseTicketsItemNumberMax),
  "property": zod.string().uuid().nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "relatedInvoices": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesPartialUpdateResponseRelatedInvoicesItemNumberMax),
  "proposedAmount": zod.string().regex(invoicesPartialUpdateResponseRelatedInvoicesItemProposedAmountRegExp).nullish(),
  "reviewedAmount": zod.string().regex(invoicesPartialUpdateResponseRelatedInvoicesItemReviewedAmountRegExp).nullish(),
  "kind": zod.enum(['invoice', 'proposal', 'credit']).describe('\* `invoice` - Invoice\n\* `proposal` - Proposal\n\* `credit` - Credit'),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "isVoid": zod.boolean().optional(),
  "pageNumber": zod.number().min(invoicesPartialUpdateResponseRelatedInvoicesItemAttachmentsItemPageNumberMin).max(invoicesPartialUpdateResponseRelatedInvoicesItemAttachmentsItemPageNumberMax).nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])'))
}).strict()),
  "parentInvoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesPartialUpdateResponseParentInvoiceOneNumberMax),
  "proposedAmount": zod.string().regex(invoicesPartialUpdateResponseParentInvoiceOneProposedAmountRegExp).nullish()
}).strict().nullable(),
  "adjustmentSource": zod.union([zod.enum(['manual', 'agent']).describe('\* `manual` - Manual\n\* `agent` - Agent'),zod.enum(['']),zod.literal(null)]).nullish().describe('How the adjustment link was created: manually by consultant or automatically by agent.\n\n\* `manual` - Manual\n\* `agent` - Agent'),
  "adjustments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesPartialUpdateResponseAdjustmentsItemNumberMax),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "proposedAmount": zod.string().regex(invoicesPartialUpdateResponseAdjustmentsItemProposedAmountRegExp).nullish(),
  "adjustmentSource": zod.union([zod.enum(['manual', 'agent']).describe('\* `manual` - Manual\n\* `agent` - Agent'),zod.enum(['']),zod.literal(null)]).nullish().describe('How the adjustment link was created: manually by consultant or automatically by agent.\n\n\* `manual` - Manual\n\* `agent` - Agent'),
  "savingsDelta": zod.number().nullable()
}).strict()),
  "keepOnFileOnly": zod.boolean().optional(),
  "creditedInvoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesPartialUpdateResponseCreditedInvoiceOneNumberMax),
  "status": zod.enum(['pending', 'approved', 'rejected', 'partial-approval', 'pending-data', 'reset']).describe('\* `pending` - Pending\n\* `approved` - Approved\n\* `rejected` - Rejected\n\* `partial-approval` - Partial Approval\n\* `pending-data` - Pending Data\n\* `reset` - Reset'),
  "proposedAmount": zod.string().regex(invoicesPartialUpdateResponseCreditedInvoiceOneProposedAmountRegExp).nullish(),
  "reviewedAmount": zod.string().regex(invoicesPartialUpdateResponseCreditedInvoiceOneReviewedAmountRegExp).nullish(),
  "savings": zod.string().regex(invoicesPartialUpdateResponseCreditedInvoiceOneSavingsRegExp).nullish(),
  "disputeSavings": zod.string().regex(invoicesPartialUpdateResponseCreditedInvoiceOneDisputeSavingsRegExp).nullish()
}).strict().nullable(),
  "credits": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string().max(invoicesPartialUpdateResponseCreditsItemNumberMax),
  "date": zod.string().date().nullish(),
  "proposedAmount": zod.string().regex(invoicesPartialUpdateResponseCreditsItemProposedAmountRegExp).nullish(),
  "keepOnFileOnly": zod.boolean().optional()
}).strict()),
  "countsTowardSpend": zod.boolean().nullable(),
  "stampFile": zod.string().url().nullable(),
  "insights": zod.unknown().nullable(),
  "insightStatus": zod.enum(['pending', 'processing', 'completed', 'failed']).describe('\* `pending` - Pending\n\* `processing` - Processing\n\* `completed` - Completed\n\* `failed` - Failed').optional().describe('Current status of insight generation\n\n\* `pending` - Pending\n\* `processing` - Processing\n\* `completed` - Completed\n\* `failed` - Failed'),
  "activeContractId": zod.string().uuid().nullable().describe('Id of the contract whose terms govern this invoice (by property + date\noverlap), or None when it can\'t be resolved. Powers the AI-vs-consultant\nrule-suggestion flow, which needs the contract to draft a review rule.\n\nResolved only for single-object (detail) responses — the rule-suggestion\nchat tool loops back to the invoice detail endpoint. Skipped during list\nserialization because find_active_property_contract issues per-invoice\nqueries the list queryset can\'t prefetch, which would N+1.'),
  "source": zod.string().nullable(),
  "emailContext": zod.object({
  "sender": zod.string(),
  "subject": zod.string(),
  "textBody": zod.string(),
  "receivedAt": zod.string().datetime({"offset":true})
}).strict().nullable(),
  "uploadedBy": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(invoicesPartialUpdateResponseUploadedByOneUsernameMax).regex(invoicesPartialUpdateResponseUploadedByOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(invoicesPartialUpdateResponseUploadedByOneEmailMax).optional(),
  "phoneNumber": zod.string().max(invoicesPartialUpdateResponseUploadedByOnePhoneNumberMax).optional()
}).strict().nullable(),
  "uploadedAt": zod.string().datetime({"offset":true}).nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "projectedSavings": zod.number().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Basic API CRUD access to Invoice entities.
 */
export const InvoicesDestroyParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this invoice.')
})

export const InvoicesDestroyResponse = zod.void()

/**
 * Force-generate and return the invoice's insights object. Returns `{insights: []}` when none were produced, or `{error, code}` on a generation failure.
 */
export const InvoicesGenerateInsightsCreateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this invoice.')
})

export const InvoicesGenerateInsightsCreateResponse = zod.record(zod.string(), zod.unknown())

/**
 * Generate and return the stamped invoice PDF as a binary download.
 */
export const InvoicesStampedPdfRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this invoice.')
})

export const InvoicesStampedPdfRetrieveQueryParams = zod.object({
  "include_supporting_data": zod.boolean().optional().describe('Append the invoice\'s supporting documents to the PDF.')
})

export const InvoicesStampedPdfRetrieveResponse = zod.unknown()

/**
 * Basic API CRUD access to Invoice entities.
 */
export const InvoicesAggregateRetrieveQueryParams = zod.object({
  "date_after": zod.string().date().optional().describe('Explicit start of the date range (inclusive).'),
  "date_before": zod.string().date().optional().describe('Explicit end of the date range (inclusive).'),
  "group_by": zod.string().optional().describe('Optional whitelisted group-by dimension (entity-specific, e.g. ``property``, ``portfolio``, ``entry_type``). Omit for a single scalar value; an unknown value returns 400 listing the valid dimensions.'),
  "limit": zod.number().optional().describe('Top-N rows for a grouped result, clamped to [1, 50]. Ignored for scalar results.'),
  "metric": zod.string().describe('Whitelisted metric to compute (entity-specific, e.g. ``invoice_amount``, ``ticket_count``, ``unit_count``). An unknown value returns 400 listing the entity\'s valid metrics.'),
  "period": zod.string().optional().describe('Named relative date range (one of ``30d``\/``90d``\/``ytd``\/``ttm``\/``all``\/``custom``) resolved into the entity\'s date filter. ``all`` applies no date bound at all. Routed to ``dropped_filters`` for entities without a date filter.')
})

export const InvoicesAggregateRetrieveResponse = zod.union([zod.object({
  "entity": zod.string(),
  "metric": zod.string(),
  "value": zod.number().nullable(),
  "filtersApplied": zod.record(zod.string(), zod.unknown()),
  "droppedFilters": zod.record(zod.string(), zod.unknown())
}).strict().describe('Ungrouped aggregate: a single scalar ``value`` for the whole scope.'),zod.object({
  "entity": zod.string(),
  "metric": zod.string(),
  "groupBy": zod.string(),
  "rows": zod.array(zod.object({
  "group": zod.string().nullable(),
  "value": zod.number().nullable()
}).strict().describe('One row of a grouped aggregate: a display label and its metric value.')),
  "total": zod.number().nullable(),
  "groupCount": zod.number(),
  "shown": zod.number(),
  "truncated": zod.boolean(),
  "filtersApplied": zod.record(zod.string(), zod.unknown()),
  "droppedFilters": zod.record(zod.string(), zod.unknown())
}).strict().describe('Grouped aggregate: top-N rows plus the grand total and group count.')])

